try {
            require('./index.css');
          } catch (e) {
            if (e.code !== 'MODULE_NOT_FOUND') {
              throw e; // Re-throw unexpected errors
            }
            console.warn('index.css not found, proceeding without it.');
          }
          

import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import require$$0, { forwardRef, useMemo, useState, useEffect, useCallback } from 'react';
import { ErrorMessage } from '@design-system/error-message';
import { RTEText } from '@design-system/rte-text';
import { Tooltip } from '@design-system/tooltip';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest$4(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var src = {};

var IcomoonReact$1 = {};

(function (exports) {

  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }

      return t;
    };

    return __assign.apply(this, arguments);
  };

  var __rest = commonjsGlobal && commonjsGlobal.__rest || function (s, e) {
    var t = {};

    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };

  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.IcomoonReact = exports.iconList = void 0;

  var react_1 = __importDefault(require$$0);

  exports.iconList = function (iconSet) {
    var list = [];
    iconSet.icons.forEach(function (icon) {
      list.push(icon.properties.name.split(", ")[0]);
    });
    return list;
  };

  function getSvg(icon, iconSet, styles, size, className, rest) {
    var find = function (iconEl) {
      return iconEl.properties.name.split(", ").includes(icon);
    };

    var currentIcon = iconSet.icons.find(find);

    var renderPath = function (iconObj) {
      return function (path, index) {
        var attrs = iconObj.attrs && iconObj.attrs[index] || {};
        return react_1.default.createElement("path", __assign({
          style: styles.path,
          key: index,
          d: path
        }, attrs));
      };
    };

    if (currentIcon) {
      return react_1.default.createElement("svg", __assign({
        className: className,
        style: styles.svg,
        width: size,
        height: size,
        viewBox: "0 0 " + (currentIcon.icon.width || "1024") + " 1024",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), currentIcon.icon.paths.map(renderPath(currentIcon.icon)));
    }

    console.warn("icon " + icon + " does not exist.");
    return null;
  }

  exports.IcomoonReact = function (props) {
    var color = props.color,
        _a = props.size,
        size = _a === void 0 ? "100%" : _a,
        icon = props.icon,
        iconSet = props.iconSet,
        _b = props.className,
        className = _b === void 0 ? "" : _b,
        _c = props.style,
        style = _c === void 0 ? {} : _c,
        rest = __rest(props, ["color", "size", "icon", "iconSet", "className", "style"]);

    var styles = {
      svg: __assign({
        display: "inline-block",
        verticalAlign: "middle"
      }, style),
      path: {
        fill: color
      }
    };
    return getSvg(icon, iconSet, styles, size, className, rest);
  };

  exports.IcomoonReact.displayName = "IcomoonReact";
  exports.default = exports.IcomoonReact;
})(IcomoonReact$1);

(function (exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var IcomoonReact_1 = IcomoonReact$1;
  var IcomoonReact_2 = IcomoonReact$1;
  Object.defineProperty(exports, "iconList", {
    enumerable: true,
    get: function () {
      return IcomoonReact_2.iconList;
    }
  });
  exports.default = IcomoonReact_1.IcomoonReact;
})(src);

var IcomoonReact = /*@__PURE__*/getDefaultExportFromCjs(src);

try {
  if (process.env.TOKENS_FEATURE_FLAG === 'true') require('./index-new.css');else require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css not found, proceeding without it.');
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest$3(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var IcoMoonType = "selection";
var icons = [{
  icon: {
    paths: ["M352.107 729.152v-434.304l345.515 217.152-345.515 217.152zM742.635 580.454c50.974-32.034 50.974-104.875 0-136.909l-345.514-217.154c-55.399-34.817-128.256 4.070-128.256 68.456v434.304c0 64.388 72.858 103.275 128.256 68.454l345.514-217.152z"],
    attrs: [{}],
    isMulticolor: false,
    isMulticolor2: false,
    grid: 0,
    tags: ["play"],
    colorPermutations: {
      "111311311311867129125525525512929271": [{}]
    }
  },
  attrs: [{}],
  properties: {
    order: 139,
    id: 44,
    name: "play",
    prevSize: 32,
    code: 59654
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 0
}, {
  icon: {
    paths: ["M725.333 768v-512c0-23.564-19.102-42.667-42.667-42.667h-42.667c-23.565 0-42.667 19.103-42.667 42.667v512c0 23.565 19.102 42.667 42.667 42.667h42.667c23.565 0 42.667-19.102 42.667-42.667z", "M426.667 768v-512c0-23.564-19.103-42.667-42.667-42.667h-42.667c-23.564 0-42.667 19.103-42.667 42.667v512c0 23.565 19.103 42.667 42.667 42.667h42.667c23.564 0 42.667-19.102 42.667-42.667z"],
    attrs: [{}, {}],
    isMulticolor: false,
    isMulticolor2: false,
    grid: 0,
    tags: ["pause"],
    colorPermutations: {
      "111311311311867129125525525512929271": [{}, {}]
    }
  },
  attrs: [{}, {}],
  properties: {
    order: 138,
    id: 43,
    name: "pause",
    prevSize: 32,
    code: 59659
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 1
}, {
  icon: {
    paths: ["M356.863 598.221l241.359-241.359c16.662-16.662 43.677-16.662 60.34 0l30.17 30.17c16.662 16.662 16.662 43.677 0 60.34l-241.359 241.359c-16.662 16.662-43.677 16.662-60.34 0l-30.17-30.17c-16.662-16.662-16.662-43.677 0-60.34z", "M266.353 628.395l-90.51 90.509c-16.662 16.661-16.662 43.678 0 60.339l90.51 90.509c16.662 16.661 43.677 16.661 60.34 0l233.286-233.284c7.603 28.467 0.239 60.1-22.097 82.436l-181.019 181.018c-33.325 33.327-87.355 33.327-120.68 0l-90.51-90.509c-33.325-33.323-33.324-87.356 0-120.678l181.019-181.022c22.334-22.332 53.969-29.7 82.438-22.097l-142.777 142.78zM636.463 559.983c28.471 7.599 60.105 0.235 82.436-22.101l181.022-181.017c33.323-33.325 33.323-87.355 0-120.68l-90.509-90.51c-33.327-33.325-87.356-33.325-120.683 0l-181.018 181.019c-22.336 22.334-29.7 53.969-22.097 82.438l233.284-233.287c16.666-16.663 43.678-16.663 60.343 0l90.509 90.51c16.661 16.662 16.661 43.677 0 60.34l-233.289 233.289z", "M559.979 636.467l20.612-5.504c-1.967-7.369-7.718-13.124-15.083-15.1-7.364-1.98-15.223 0.124-20.612 5.517l15.083 15.087zM409.13 485.615l15.085 15.087c5.392-5.393 7.495-13.252 5.52-20.617s-7.734-13.111-15.101-15.078l-5.504 20.608zM636.463 559.983l-15.083-15.087c-5.393 5.393-7.497 13.252-5.521 20.617s7.735 13.111 15.1 15.078l5.504-20.608zM485.615 409.132l-20.612 5.504c1.967 7.367 7.718 13.123 15.083 15.098 7.364 1.98 15.223-0.128 20.612-5.518l-15.083-15.085zM190.928 733.986l90.51-90.509-30.17-30.17-90.51 90.509 30.17 30.17zM190.928 764.156c-8.331-8.329-8.331-21.837 0-30.17l-30.17-30.17c-24.994 24.994-24.994 65.519 0 90.513l30.17-30.174zM281.437 854.669l-90.51-90.513-30.17 30.174 90.51 90.509 30.17-30.17zM311.607 854.669c-8.331 8.329-21.839 8.329-30.17 0l-30.17 30.17c24.993 24.994 65.516 24.994 90.51 0l-30.17-30.17zM402.117 764.156l-90.51 90.513 30.17 30.17 90.508-90.509-30.169-30.174zM492.625 673.647l-90.508 90.509 30.169 30.174 90.509-90.513-30.17-30.17zM544.896 621.38l-52.271 52.267 30.17 30.17 52.271-52.267-30.17-30.17zM539.366 641.971c5.722 21.414 0.162 45.116-16.572 61.845l30.174 30.17c27.934-27.934 37.107-67.503 27.622-103.023l-41.225 11.008zM522.795 703.817l-181.017 181.022 30.17 30.17 181.021-181.022-30.174-30.17zM341.777 884.838c-24.994 24.994-65.516 24.994-90.51 0l-30.17 30.17c41.656 41.655 109.193 41.655 150.849 0l-30.17-30.17zM251.268 884.838l-90.51-90.509-30.17 30.17 90.51 90.509 30.17-30.17zM160.758 794.33c-24.994-24.994-24.994-65.519 0-90.513l-30.17-30.17c-41.656 41.655-41.656 109.197 0 150.852l30.17-30.17zM160.758 703.817l181.019-181.018-30.17-30.17-181.019 181.018 30.17 30.17zM341.777 522.799c16.732-16.734 40.434-22.289 61.848-16.572l11.008-41.22c-35.523-9.489-75.089-0.316-103.026 27.622l30.17 30.17zM371.947 552.969l52.268-52.267-30.17-30.17-52.267 52.267 30.17 30.17zM281.437 643.477l90.51-90.509-30.17-30.17-90.51 90.509 30.17 30.17zM703.817 522.799c-16.734 16.73-40.435 22.289-61.85 16.572l-11.008 41.22c35.524 9.489 75.089 0.316 103.027-27.622l-30.17-30.17zM884.834 341.78l-181.018 181.019 30.17 30.17 181.018-181.019-30.17-30.17zM884.834 251.27c24.994 24.994 24.994 65.516 0 90.51l30.17 30.17c41.655-41.656 41.655-109.193 0-150.849l-30.17 30.17zM794.325 160.76l90.509 90.51 30.17-30.17-90.509-90.51-30.17 30.17zM703.817 160.76c24.994-24.993 65.515-24.993 90.509 0l30.17-30.17c-41.655-41.656-109.193-41.656-150.848 0l30.17 30.17zM522.795 341.78l181.022-181.020-30.17-30.17-181.022 181.019 30.17 30.17zM506.227 403.628c-5.722-21.414-0.162-45.117 16.567-61.848l-30.17-30.17c-27.934 27.937-37.107 67.503-27.622 103.026l41.225-11.008zM500.698 424.217l52.271-52.268-30.174-30.17-52.267 52.267 30.17 30.17zM552.969 371.949l90.509-90.51-30.17-30.17-90.513 90.51 30.174 30.17zM643.477 281.44l90.509-90.51-30.17-30.17-90.509 90.51 30.17 30.17zM733.986 190.93c8.333-8.331 21.837-8.331 30.17 0l30.17-30.17c-24.994-24.993-65.515-24.993-90.509 0l30.17 30.17zM764.156 190.93l90.509 90.51 30.17-30.17-90.509-90.51-30.17 30.17zM854.665 281.44c8.333 8.331 8.333 21.839 0 30.17l30.17 30.17c24.994-24.994 24.994-65.516 0-90.51l-30.17 30.17zM854.665 311.61l-90.509 90.51 30.17 30.171 90.509-90.511-30.17-30.17zM764.156 402.119l-90.509 90.51 30.17 30.17 90.509-90.509-30.17-30.171zM673.647 492.629l-52.267 52.267 30.17 30.17 52.267-52.267-30.17-30.17z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["copy"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 152,
    id: 0,
    name: "copy",
    prevSize: 32,
    code: 59700
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 2
}, {
  icon: {
    paths: ["M553.31 896c-319.921 0-502.733-287.134-510.643-768h160.839c5.274 351.71 123.046 500.467 217.089 531.605v-531.605h151.169v303.279c92.288-12.684 189.845-151.063 222.366-303.279h151.168c-12.305 78.415-36.911 153.369-72.068 219.099s-80.858 121.082-132.715 163.749c58.889 38.054 109.862 92.25 152.051 159.134 41.306 66.884 72.068 142.993 88.768 226.018h-166.114c-36.032-145.297-124.804-259.46-242.577-274.449v274.449h-19.332z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["vkontakte"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 164,
    id: 1,
    name: "vkontakte",
    prevSize: 32,
    code: 59701
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 3
}, {
  icon: {
    paths: ["M47.161 1002.667l381.020-433.391-385.887-547.942h249.411l275.005 390.424 275.529-313.391 68.070-77.033h30.212l-360.311 409.626 402.675 571.708h-249.425l-13.978-19.81-277.773-394.428-364.352 414.238h-30.198zM740.809 969.617l6.374 9.050h188.151l-657.354-933.333h-188.154l650.982 924.283z"],
    attrs: [{
      strokeLinejoin: "miter",
      strokeLinecap: "butt",
      strokeMiterlimit: "4",
      strokeWidth: 42.666666666666664
    }],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": [{}]
    },
    tags: ["x"],
    grid: 0
  },
  attrs: [{
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: "4",
    strokeWidth: 42.666666666666664
  }],
  properties: {
    order: 165,
    id: 2,
    name: "twitter",
    prevSize: 32,
    code: 59702
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 4
}, {
  icon: {
    paths: ["M512 0c282.77 0 512 229.23 512 512s-229.23 512-512 512c-282.77 0-512-229.23-512-512s229.23-512 512-512z", "M723.772 341.333l-221.252 251.328-116.957-147.034-44.229 45.056 161.186 191.983 265.481-296.277-44.228-45.056z"],
    attrs: [{
      fill: "rgb(113, 113, 113)"
    }, {
      fill: "rgb(255, 255, 255)"
    }],
    isMulticolor: true,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": [{
        f: 3
      }, {
        f: 4
      }]
    },
    tags: ["checked"],
    grid: 0
  },
  attrs: [{
    fill: "rgb(113, 113, 113)"
  }, {
    fill: "rgb(255, 255, 255)"
  }],
  properties: {
    order: 140,
    id: 3,
    name: "checked",
    prevSize: 32,
    code: 59695,
    codes: [59695, 59696]
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 5
}, {
  icon: {
    paths: ["M552.592 12.299c-12.018-8.019-26.145-12.299-40.592-12.299s-28.574 4.28-40.592 12.299l-406.238 270.775c-20.053 13.362-36.494 31.47-47.863 52.716s-17.314 44.971-17.307 69.067v472.87c0 38.796 15.412 76.004 42.846 103.438s64.642 42.845 103.44 42.845h146.285c19.399 0 38.003-7.703 51.72-21.42s21.423-32.321 21.423-51.721v-292.571h292.574v292.571c0 19.4 7.703 38.004 21.42 51.721s32.321 21.42 51.721 21.42h146.283c38.8 0 76.009-15.411 103.443-42.845s42.845-64.642 42.845-103.438v-472.87c0.005-24.077-5.935-47.784-17.292-69.015s-27.778-39.332-47.807-52.695l-406.309-270.848z"],
    attrs: [{}],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": [{}]
    },
    tags: ["delivered"],
    grid: 0
  },
  attrs: [{}],
  properties: {
    order: 141,
    id: 4,
    name: "delivered",
    prevSize: 32,
    code: 59697
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 6
}, {
  icon: {
    paths: ["M0 85.333v853.335c0 22.63 8.99 44.335 24.994 60.337s37.708 24.995 60.34 24.995h853.335c22.63 0 44.335-8.993 60.337-24.995s24.995-37.706 24.995-60.337v-853.335c0-22.632-8.993-44.337-24.995-60.34s-37.706-24.994-60.337-24.994h-853.335c-22.632 0-44.337 8.99-60.34 24.994s-24.994 37.708-24.994 60.34zM398.222 227.556h455.109v113.778h-455.109v-113.778zM853.332 455.111v113.777h-455.109v-113.777h455.109zM398.222 682.668h455.109v113.776h-455.109v-113.776zM227.556 341.333c-15.088 0-29.558-5.994-40.226-16.662s-16.662-25.139-16.662-40.226c0-15.088 5.994-29.558 16.662-40.226s25.139-16.662 40.226-16.662c15.088 0 29.558 5.994 40.226 16.662s16.662 25.139 16.662 40.226c0 15.088-5.994 29.558-16.662 40.226s-25.139 16.662-40.226 16.662zM284.444 512c0 15.090-5.994 29.556-16.662 40.225-10.669 10.673-25.139 16.663-40.226 16.663s-29.558-5.99-40.226-16.663c-10.669-10.668-16.662-25.135-16.662-40.225s5.994-29.556 16.662-40.225c10.669-10.671 25.139-16.664 40.226-16.664s29.558 5.994 40.226 16.664c10.669 10.668 16.662 25.135 16.662 40.225zM227.556 796.444c-15.088 0-29.558-5.995-40.226-16.663s-16.662-25.139-16.662-40.225c0-15.090 5.994-29.556 16.662-40.229 10.669-10.668 25.139-16.659 40.226-16.659s29.558 5.99 40.226 16.659c10.669 10.673 16.662 25.139 16.662 40.229 0 15.085-5.994 29.556-16.662 40.225s-25.139 16.663-40.226 16.663z"],
    attrs: [{}],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": [{}]
    },
    tags: ["pending"],
    grid: 0
  },
  attrs: [{}],
  properties: {
    order: 142,
    id: 5,
    name: "pending",
    prevSize: 32,
    code: 59698
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 7
}, {
  icon: {
    paths: ["M76.8 139.636c-20.369 0-39.903 8.091-54.306 22.494s-22.494 33.937-22.494 54.306v563.2c0 20.368 8.091 39.903 22.494 54.305 14.403 14.406 33.937 22.495 54.306 22.495h25.6c0 40.737 16.183 79.807 44.989 108.614 28.806 28.802 67.874 44.986 108.611 44.986s79.806-16.184 108.611-44.986c28.806-28.807 44.989-67.877 44.989-108.614h204.8c0 40.737 16.184 79.807 44.986 108.614 28.807 28.802 67.877 44.986 108.614 44.986s79.807-16.184 108.614-44.986c28.802-28.807 44.986-67.877 44.986-108.614h25.6c20.368 0 39.903-8.090 54.305-22.495 14.406-14.401 22.495-33.936 22.495-54.305v-172.083c0-13.926-3.789-27.587-10.957-39.526l-142.49-237.517c-6.824-11.368-16.472-20.776-28.011-27.308s-24.571-9.965-37.832-9.966h-139.11v-76.8c0-20.369-8.090-39.903-22.495-54.306-14.401-14.403-33.936-22.494-54.305-22.494h-512zM768 907.636c-13.577 0-26.601-5.395-36.203-14.997s-14.997-22.626-14.997-36.203c0-13.577 5.395-26.601 14.997-36.203s22.626-14.997 36.203-14.997c13.577 0 26.601 5.395 36.203 14.997s14.997 22.626 14.997 36.203c0 13.577-5.395 26.601-14.997 36.203s-22.626 14.997-36.203 14.997zM204.8 856.436c0 13.577 5.394 26.601 14.996 36.203s22.625 14.997 36.204 14.997c13.579 0 26.602-5.395 36.204-14.997s14.996-22.626 14.996-36.203c0-13.577-5.394-26.601-14.996-36.203s-22.625-14.997-36.204-14.997c-13.579 0-26.602 5.395-36.204 14.997s-14.996 22.626-14.996 36.203zM882.381 549.236h-216.781v-153.6h124.621l92.16 153.6z"],
    attrs: [{}],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": [{}]
    },
    tags: ["sent"],
    grid: 0
  },
  attrs: [{}],
  properties: {
    order: 143,
    id: 6,
    name: "sent",
    prevSize: 32,
    code: 59699
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 8
}, {
  icon: {
    paths: ["M888.747 688.64l-73.813-333.227c-4.267-19.627-21.333-33.28-41.813-33.28h-136.533v-42.667h85.333c23.467 0 42.667-19.2 42.667-42.667v-85.333c0-23.467-19.2-42.667-42.667-42.667h-426.667c-23.467 0-42.667 19.2-42.667 42.667v85.333c0 23.467 19.2 42.667 42.667 42.667h85.333v42.667h-136.533c-20.053 0-37.12 13.653-41.813 33.28l-74.24 333.227c-2.133 5.12-3.413 10.667-3.84 16.64v0.853s0 0 0 0v170.667c0 23.467 19.2 42.667 42.667 42.667h683.093c23.467 0 42.667-19.2 42.667-42.667v-170.667c0-6.4-1.28-11.947-3.84-17.493zM647.68 409.6c0 11.947-11.52 21.333-25.6 21.333s-25.6-9.387-25.6-21.333 11.52-21.333 25.6-21.333 25.6 9.387 25.6 21.333zM622.080 516.267c-14.080 0-25.6-9.387-25.6-21.333s11.52-21.333 25.6-21.333 25.6 9.387 25.6 21.333-11.52 21.333-25.6 21.333zM647.68 580.267c0 11.947-11.52 21.333-25.6 21.333s-25.6-9.387-25.6-21.333 11.52-21.333 25.6-21.333 25.6 9.387 25.6 21.333zM295.253 236.8v-85.333h426.667v85.333h-426.667zM519.68 516.693c-14.080 0-25.6-9.387-25.6-21.333s11.52-21.333 25.6-21.333 25.6 9.387 25.6 21.333-11.52 21.333-25.6 21.333zM545.28 580.693c0 11.947-11.52 21.333-25.6 21.333s-25.6-9.387-25.6-21.333 11.52-21.333 25.6-21.333 25.6 9.387 25.6 21.333zM519.68 431.36c-14.080 0-25.6-9.387-25.6-21.333s11.52-21.333 25.6-21.333 25.6 9.387 25.6 21.333-11.52 21.333-25.6 21.333zM417.28 516.693c-14.080 0-25.6-9.387-25.6-21.333s11.52-21.333 25.6-21.333 25.6 9.387 25.6 21.333-11.52 21.333-25.6 21.333zM442.88 580.693c0 11.947-11.52 21.333-25.6 21.333s-25.6-9.387-25.6-21.333 11.52-21.333 25.6-21.333 25.6 9.387 25.6 21.333zM417.28 431.36c-14.080 0-25.6-9.387-25.6-21.333s11.52-21.333 25.6-21.333 25.6 9.387 25.6 21.333-11.52 21.333-25.6 21.333zM849.92 876.8h-682.667v-170.667h682.667v170.667z", "M284.587 815.36h469.333c11.947 0 21.333-9.387 21.333-21.333s-9.387-21.333-21.333-21.333h-469.333c-11.947 0-21.333 9.387-21.333 21.333s9.387 21.333 21.333 21.333z"],
    attrs: [{
      fill: "currentColor"
    }, {
      fill: "currentColor"
    }],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "11867129125525525512929271": [{
        f: 3
      }, {
        f: 3
      }],
      "111311311311867129125525525512929271": [{
        f: 0
      }, {
        f: 0
      }]
    },
    tags: ["cashRegister"],
    grid: 0
  },
  attrs: [{
    fill: "currentColor"
  }, {
    fill: "currentColor"
  }],
  properties: {
    order: 137,
    id: 7,
    name: "cashRegister",
    prevSize: 32,
    code: 59678
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 9
}, {
  icon: {
    paths: ["M499.962 876.515h-239.521c-7.544 0-15.182 0.378-22.632-0.376-67.331-6.883-94.583-49.602-65.915-111.274 56.257-120.889 114.479-240.854 174.642-359.847 26.97-48.093 24.047-67.896 25.839-115.328-0.095-42.529 8.204-70.914-14.24-104.484-10.845-16.315 6.224-40.738 27.064-41.021 77.326-0.943 154.651-1.32 231.883 0.283 26.592 0.566 36.21 30.836 20.745 53.090-6.924 10.487-11.344 22.424-12.919 34.891-10.278 79.494 12.165 150.596 49.885 220.661 50.45 93.734 94.112 190.956 140.13 287.048 7.429 15.95 13.363 32.556 17.727 49.601 10.939 40.644-9.523 74.026-50.733 82.89-13.012 2.83-26.592 3.677-39.983 3.772-80.626 0.283-161.346 0.093-241.973 0.093zM500.433 863.974v0.943c18.482 0 36.965 0.188 55.448 0 73.082-0.754 146.164-0.283 219.153-3.111 34.891-1.321 54.505-28.291 47.621-62.804-5.024-23.669-12.942-46.631-23.575-68.367-44.981-94.676-87.793-190.58-138.055-282.333-38.662-70.536-55.825-142.675-47.056-221.509 1.226-11.034 9.148-21.218 12.826-32.157 3.018-8.958 7.826-19.331 5.563-27.347-1.885-6.602-12.824-15.087-19.897-15.182-73.957-1.179-147.927-1.272-221.887-0.283-21.123 0.283-29.704 22.349-19.802 41.020 6.129 11.693 11.317 25.273 11.976 38.286 1.697 32.723 1.602 65.539 0.095 98.26-0.429 15.768-3.92 31.301-10.279 45.735-36.966 78.080-75.345 155.5-113.348 233.109-25.085 51.205-52.997 101.183-74.969 153.614-23.764 56.769-9.147 101.090 58.937 101.844 85.813 1.038 171.531 0.283 257.25 0.283z", "M269.493 634.261c37.436-76.949 72.516-152.011 110.33-225.659 16.22-31.59 25.273-62.993 23.103-98.638-1.885-31.779 0.566-63.84-0.943-95.714-0.471-10.75-4.903-21.311-8.769-33.288-0.258-0.757-0.328-1.566-0.208-2.358 0.12-0.791 0.429-1.542 0.901-2.188 0.471-0.648 1.092-1.172 1.809-1.528 0.715-0.358 1.507-0.539 2.307-0.526h200.386c5.847 0 9.336 6.883 5.471 11.315-9.713 11.034-7.828 25.083-9.808 38.474-14.616 100.524 22.349 187.091 68.462 272.244 23.858 44.038 43.943 90.15 67.046 137.867h-460.088zM513.917 205.857c0 23.48-1.98 49.413-0.471 68.367 4.715 58.466 10.939 106.653 45.359 153.52 39.7 54.034 73.27 112.5 109.576 169.079-31.59-74.12-66.387-146.354-100.052-219.153-6.124-13.542-9.552-28.148-10.089-43-1.321-42.529-0.471-85.153-0.471-128.813h-43.85z"],
    width: 1039,
    attrs: [{
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "186712912552552551": [{
        f: 1
      }, {
        f: 1
      }],
      "111311311311867129125525525512929271": [{
        f: 4
      }, {
        f: 4
      }]
    },
    tags: ["burette"],
    grid: 0
  },
  attrs: [{
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }],
  properties: {
    order: 146,
    id: 8,
    name: "burette",
    prevSize: 32,
    code: 59679
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 10
}, {
  icon: {
    paths: ["M770.885 928.285h-523.93v-391.721c5.941-0.376 12.071-1.131 18.2-1.131 161.063-0.095 322.128 0.283 483.191-0.566 19.709-0.095 24.424 5.564 24.236 24.612-0.849 115.894-0.378 231.695-0.471 347.589-0.095 6.883-0.754 13.673-1.226 21.216zM447.154 680.276c13.014-43.377 35.551-60.917 73.272-58.654 27.347 1.604 46.395 15.937 52.335 39.323 5.281 20.463-5.186 40.078-29.044 54.6-7.638 4.62-15.087 9.43-22.632 14.145-29.139 18.388-37.060 39.7-27.913 73.742h28.196c-9.618-35.080 11.881-49.79 37.155-62.709 10.228-5.174 19.87-11.434 28.761-18.671 9.202-6.936 16.202-16.387 20.15-27.214 3.95-10.826 4.68-22.564 2.104-33.797-6.412-33.288-31.967-56.014-72.044-63.559-58.842-11.032-110.52 22.067-118.629 77.326l28.29 5.469zM526.837 872.46v-37.531h-39.889v37.531h39.889zM557.579 159.083c-3.111 0 2.452 12.353-3.299 12.353-1.509 8.77-2.075 7.261-4.244 14.711l-5.469 11.598c-6.224 8.677-3.018 20.275-7.45 32.911 2.923-3.96 8.297-5.374 9.995-7.733 3.679 3.301 6.319 6.79 9.808 8.675 23.953 12.637 47.904 25.367 72.328 37.060 20.369 9.713 27.442 26.687 29.422 47.434 4.81 50.543 10.184 100.995 14.333 151.538 1.509 18.2 0.283 36.588 0.283 56.392l-341.271-0.095c4.527-45.359 8.487-89.585 13.485-133.623 2.83-24.517 8.864-48.753 10.844-73.27 2.924-35.929 16.032-61.767 54.789-68.933 17.917-3.301 35.739-7.921 46.678-26.781-2.64-5.376 2.358 4.903 0 0 1.038-2.735 4.998-2.263 4.527-3.301-4.149-9.336-1.98-8.487-8.77-15.277-11.032-11.032-12.729-22.254-8.958-36.022z", "M444.515 166.722c-19.991-26.97-15.371-48.848 13.014-62.427 2.168-1.037 3.582-3.395 5.374-5.092 21.123-18.766 46.396-18.483 67.141 0.943 2.735 2.64 4.81 6.412 8.016 8.016 21.877 11.316 28.101 28.29 19.521 50.921z", "M490.062 533.076h-2.358v-64.407c-8.958-43.377-60.163-149.465-60.729-150.502l-0.093-0.283c-0.944-4.525 10.749-14.145 17.351-19.236h-9.242v-44.509c0-12.448 22.727-35.929 23.669-36.872l2.357-2.452-0.376 3.394c-2.923 26.026 9.242 77.326 10.089 80.815 10.091 16.596 18.955 101.466 19.333 105.050v129.001zM429.145 317.225c2.168 4.432 45.452 94.488 58.559 141.639v-54.695c-0.095-0.753-9.242-88.358-19.048-104.106l-0.19-0.376c-0.565-2.075-12.165-50.357-10.466-78.363-5.847 6.412-20.652 23.575-20.652 32.816v42.151h14.145l-2.924 2.168c-9.618 6.885-19.614 15.937-19.424 18.766zM545.794 529.021l-2.358-0.093 0.376-10.467 7.733-239.333c3.018-43.284-7.826-60.446-7.921-60.539l-2.735-4.244 4.338 2.64c24.895 14.806 36.399 31.685 41.68 43.284 5.752 12.636 5.564 21.689 5.564 22.066v0.283c-1.697 5.941-12.353 15.465-16.786 19.143l13.014 2.735-5.374 20.369c-29.327 59.032-35.741 160.97-37.155 193.693l-0.376 10.466zM547.584 221.228c3.113 7.261 8.582 25.083 6.319 58.183l-5.941 183.13c4.715-43.85 14.145-100.147 33.099-138.338l4.715-17.729-15.371-3.299 1.98-1.604c0.188-0.095 15.747-12.731 17.822-19.426 0-1.226-0.188-9.618-5.374-20.935-8.276-16.658-21.218-30.55-37.25-39.983z", "M473.937 311.66h-0.283c-0.376-0.093-0.754-0.376-0.848-0.754-0.661-1.98-15.749-48.658-14.618-73.836 0-0.471 0.378-0.943 0.849-1.038 0.471-0.188 1.038 0.095 1.321 0.471 0.188 0.378 21.499 32.723 33.004 35.646h19.519c3.208-2.075 32.816-21.877 36.117-38.852 0.095-0.565 0.661-0.943 1.132-0.943 0.565 0 1.036 0.378 1.131 0.943 0.283 1.509 7.921 36.305 2.168 58.466l-0.188 0.378-12.824 19.143c-0.19 0.283-0.566 0.471-0.944 0.565-0.182 0.005-0.364-0.036-0.529-0.119-0.164-0.081-0.307-0.203-0.414-0.352l-24.234-34.325c-0.095 6.978-0.378 22.255-1.132 29.234-0.093 0.566-0.565 1.038-1.131 1.038h-15.089c-0.565 0-1.131-0.471-1.131-1.038l-3.301-27.535c-2.923 8.014-9.242 23.763-17.727 32.721-0.273 0.107-0.559 0.17-0.849 0.188zM514.863 273.563l24.707 34.891 11.693-17.539c4.338-16.974 0.471-42.341-1.414-52.62-6.507 15.749-29.705 31.779-34.986 35.268zM460.452 240.842c0.378 22.444 11.222 58.561 13.862 67.33 7.526-10.412 13.321-21.971 17.163-34.23-10.373-4.149-25.46-24.99-31.024-33.099zM497.983 304.777h12.919c0.754-8.299 1.038-25.65 1.038-30.365h-17.634l3.677 30.365z", "M514.769 527.324c-0.378 0-0.661-0.188-0.943-0.471-7.617-9.678-14.851-19.65-21.689-29.893l-0.188-0.565c-1.321-13.014-0.095-71.668 0-74.12 0.188-23.386 3.866-115.423 3.96-116.272 0-0.66 0.565-1.131 1.131-1.131h15.087c0.471 0 0.944 0.376 1.132 0.848 5.374 17.541 23.763 184.922 24.517 191.994v0.378c-3.582 14.804-21.499 28.384-22.254 28.949-0.221 0.161-0.482 0.259-0.754 0.283zM494.211 495.828c1.509 2.168 12.354 18.293 20.747 28.573 3.677-2.923 17.351-14.616 20.463-26.781-0.754-6.885-18.671-169.552-24.236-190.58h-13.014c-0.471 10.656-3.771 93.167-3.866 115.14-0.095 0.754-1.414 60.258-0.095 73.648zM409.814 324.298c-0.218 0.002-0.432-0.060-0.616-0.178-0.185-0.117-0.331-0.285-0.422-0.483-3.018-6.507-21.594-54.411-22.349-56.486-0.283-0.565 0.093-1.319 0.66-1.509 0.66-0.188 1.321 0.095 1.509 0.661 0.188 0.471 19.331 49.884 22.255 56.296 0.282 0.566 0 1.321-0.566 1.604l-0.471 0.095zM403.683 517.046c-0.376 0-0.66-0.19-0.943-0.378-0.754-0.943-18.577-22.632-24.141-80.72-0.093-0.661 0.378-1.226 1.038-1.321 0.66-0.188 1.226 0.376 1.321 1.038 4.527 47.337 17.539 70.536 22.066 77.231 5.093-26.875 9.618-73.553 12.071-102.692l-0.566-0.283c-9.901-8.864-9.053-27.347-9.053-28.101 0-0.66 0.661-1.131 1.226-1.131 0.661 0 1.132 0.566 1.132 1.226 0 0.188-0.754 15.937 6.6 24.517l2.735-22.254c0.095-0.661 0.661-1.226 1.321-1.038 0.66 0.095 1.131 0.66 1.038 1.226-0.095 0.943-6.695 91.66-14.711 131.548-0.095 0.471-0.378 0.754-0.849 0.943-0.093 0.19-0.188 0.19-0.283 0.19zM561.918 460.183h-12.448c-0.66 0-1.131-0.565-1.131-1.131s0.566-1.132 1.131-1.132h12.448c0.661 0 1.132 0.566 1.132 1.132s-0.471 1.131-1.132 1.131z", "M511.655 430.008h-19.236c-0.661 0-1.132-0.566-1.132-1.132s0.566-1.131 1.132-1.131h19.236c0.661 0 1.132 0.565 1.132 1.131s-0.471 1.132-1.132 1.132zM617.648 348.91h-0.095c-0.66-0.095-1.131-0.661-1.036-1.321 2.545-25.65 22.254-60.068 22.442-60.351 0.378-0.566 1.038-0.754 1.604-0.471 0.566 0.376 0.754 1.036 0.471 1.602-0.188 0.378-19.709 34.325-22.161 59.409-0.042 0.301-0.188 0.578-0.411 0.785s-0.51 0.328-0.815 0.348zM626.23 534.209c-0.301 0-0.589-0.119-0.801-0.331s-0.331-0.5-0.331-0.801c0-22.82-3.489-62.898-3.582-63.369-5.469-21.877-5.093-70.63-5.093-71.102 0-0.66 0.566-1.132 1.131-1.132 0.661 0 1.132 0.566 1.132 1.227 0 0.471-0.471 48.941 4.998 70.724 0.093 0.566 3.582 40.737 3.582 63.747 0.19 0.471-0.376 1.038-1.036 1.038zM590.396 455.657c-17.729 0-23.481-13.675-23.576-13.768-1.602-10.279-2.545-59.692-2.64-61.767 0-0.66 0.471-1.226 1.132-1.226l43.094-1.038c0.661 0 1.132 0.566 1.132 1.132v62.238c-3.206 12.165-17.634 14.333-18.2 14.428h-0.943zM566.632 381.16c0.188 7.733 1.132 51.016 2.452 60.070 0.095 0.282 5.469 12.636 22.161 12.070 0 0 13.202-1.98 16.125-12.542v-60.539h-3.866l-36.872 0.943z", "M581.155 392.758c-0.301 0-0.589-0.119-0.801-0.331s-0.331-0.5-0.331-0.8v-23.010h-7.45c-0.3 0-0.587-0.119-0.8-0.331s-0.331-0.5-0.331-0.8v-19.804c0-0.66 0.565-1.131 1.131-1.131s1.132 0.566 1.132 1.131v18.671h7.45c0.66 0 1.131 0.566 1.131 1.132v24.141c0 0.565-0.471 1.131-1.131 1.131z", "M572.481 380.97c-0.301 0-0.589-0.119-0.801-0.331s-0.331-0.5-0.331-0.8v-12.448c0-0.661 0.566-1.132 1.132-1.132 0.565 0 1.131 0.566 1.131 1.132v12.448c0.095 0.66-0.471 1.131-1.131 1.131zM603.41 380.122c-0.3 0-0.587-0.12-0.8-0.331-0.212-0.212-0.331-0.501-0.331-0.801v-8.204h-21.123c-0.661 0-1.132-0.566-1.132-1.131 0-0.566 0.566-1.132 1.132-1.132h22.349c0.66 0 1.131 0.566 1.131 1.132v9.43c0 0.566-0.565 1.038-1.226 1.038zM510.526 256.024c-6.885 0-12.165-4.15-13.392-5.093-14.521-3.111-37.624-30.836-38.567-32.062-0.196-0.251-0.286-0.571-0.25-0.887 0.035-0.316 0.191-0.608 0.438-0.81 0.251-0.196 0.569-0.286 0.887-0.25 0.316 0.035 0.607 0.193 0.81 0.438 0.188 0.283 23.858 28.761 37.531 31.307l0.566 0.283c0.471 0.471 11.598 10.467 23.386 0 9.153-8.254 15.624-19.058 18.577-31.024 0.095-0.661 0.754-1.038 1.414-0.943 0.661 0.093 1.038 0.753 0.944 1.414-2.918 12.532-9.677 23.84-19.333 32.345-4.62 3.866-9.052 5.281-13.012 5.281zM480.161 191.428l-2.83-0.093c0 0-18.483 2.168-23.858-19.897l-13.673-5.847c-0.265-0.139-0.474-0.364-0.595-0.638-0.119-0.274-0.143-0.581-0.065-0.87 0.282-0.566 0.943-0.848 1.509-0.66l12.448 5.281c0.093-2.075 0.565-5.281 2.923-8.204 2.735-3.396 7.166-5.469 13.107-5.942h80.343l0.849 0.283c0.188 0.19 3.866 3.679 5.28 11.41 0.095 0.473 1.132 10.091-5.091 17.257-4.149 4.81-10.562 7.356-18.955 7.638-0.188 0-7.45 0.849-13.485-4.432-4.808-4.244-7.355-11.127-7.543-20.369h-11.788c0.471 3.584 1.226 13.202-4.338 19.521-3.206 3.677-8.014 5.563-14.238 5.563zM477.237 188.883c7.168 0.565 12.259-1.038 15.465-4.622 5.941-6.79 3.584-18.765 3.489-18.86-0.093-0.378 0-0.754 0.283-0.943 0.107-0.149 0.248-0.271 0.414-0.352 0.164-0.083 0.345-0.123 0.529-0.119h14.334c0.66 0 1.131 0.565 1.131 1.131 0 9.147 2.263 15.842 6.695 19.802 5.186 4.622 11.693 3.867 11.693 3.867 7.828-0.188 13.673-2.452 17.351-6.79 5.564-6.412 4.622-15.276 4.622-15.371-0.56-3.564-2.057-6.917-4.338-9.713h-79.682c-5.186 0.378-9.053 2.075-11.41 4.998-2.83 3.584-2.358 7.921-2.358 8.392 4.903 20.558 21.123 18.766 21.783 18.578z", "M507.318 199.822h-0.66c-2.543-0.279-4.896-1.488-6.602-3.394-3.206-0.095-5.658-1.132-7.166-3.018-2.452-3.113-1.509-7.261-1.509-7.45 0.188-0.66 0.754-1.038 1.414-0.849 0.661 0.188 1.038 0.754 0.849 1.416 0 0-0.754 3.299 1.038 5.469 1.131 1.414 3.111 2.168 5.846 2.168 0.378 0 0.754 0.188 0.944 0.471 0 0 2.074 2.735 5.28 2.923 2.075 0.188 4.527-0.848 6.885-3.111 0.283-0.283 0.66-0.378 1.131-0.283 0 0 2.168 0.471 3.867-0.754 1.319-0.943 1.98-2.735 2.074-5.374 0-0.661 0.566-1.132 1.226-1.132 0.661 0 1.132 0.566 1.132 1.226-0.188 3.301-1.226 5.658-3.113 7.073-1.885 1.414-4.149 1.414-5.186 1.319-2.357 2.17-4.903 3.301-7.45 3.301zM477.237 219.247c-0.095 0-0.095 0 0 0-0.66 0-1.226-0.566-1.131-1.226 0-0.566 0.66-13.673 10.466-16.408 0.661-0.188 1.321 0.188 1.416 0.848 0.188 0.661-0.188 1.321-0.849 1.416-8.204 2.263-8.77 14.050-8.77 14.145 0 0.66-0.565 1.226-1.131 1.226zM486.855 214.344c0 0 14.711 6.507 37.060 0 0 0-2.074 7.072-16.785 8.581 0 0-12.165 2.452-20.275-8.581zM532.119 218.21l-2.357-0.376c0.455-2.54 0.309-5.152-0.429-7.624-0.736-2.473-2.043-4.739-3.814-6.615l1.602-1.697c2.057 2.135 3.581 4.724 4.45 7.56 0.869 2.834 1.057 5.834 0.548 8.754zM439.611 160.31l-0.66-0.188c-0.126-0.086-0.233-0.194-0.316-0.322s-0.139-0.27-0.166-0.42c-0.026-0.149-0.023-0.303 0.012-0.45s0.098-0.288 0.187-0.411c0.188-0.283 20.84-28.855 20.652-42.152 0-0.377 0.188-0.754 0.471-0.943s0.66-0.283 1.038-0.189c0.283 0.094 24.424 7.261 43-8.77 0.378-0.377 0.943-0.377 1.414-0.094 0.095 0.094 12.354 7.261 28.291 4.715 0.565-0.094 1.036 0.189 1.319 0.754 0.095 0.283 11.128 27.536 27.253 38.945 0.566 0.378 0.66 1.132 0.283 1.604-0.086 0.125-0.194 0.233-0.322 0.316s-0.27 0.139-0.42 0.166c-0.149 0.026-0.303 0.023-0.45-0.012-0.149-0.035-0.288-0.098-0.411-0.187-15.276-10.751-25.65-34.231-27.723-39.041-9.66 1.41-19.521-0.239-28.196-4.715-6.054 4.626-13.067 7.839-20.522 9.406-7.457 1.566-15.169 1.446-22.573-0.353-1.226 14.522-20.18 40.927-21.028 42.057l-1.132 0.283z", "M468.185 165.212c-1.321 0.754-1.604 2.641-0.473 3.679 4.338 4.149 14.994 11.315 26.499-2.263 0 0 0-16.314-14.24-8.204l-11.787 6.789zM543.152 162.667c1.414 0.66 1.792 2.452 0.849 3.582-3.867 4.432-16.125 12.448-26.028 0.283 0 0-1.509-15.937 13.202-9.242l11.976 5.376z", "M454.886 160.875c0 0 22.066 0 29.515 4.244 0 0 12.353-10.844 5.281-11.598-15.087-1.509-27.442-3.112-34.796 7.355zM509.957 158.706c0 0 22.632 0 30.176 4.338 0 0 12.636-11.128 5.374-11.881-15.371-1.509-28.006-3.207-35.551 7.543zM460.544 117.403l-0.471-0.094c-0.471-0.189-0.754-0.754-0.66-1.32 0.093-0.66 3.111-15.559 20.745-21.972 0.66-0.283 1.321 0.094 1.509 0.66s-0.095 1.32-0.66 1.509c-3.896 1.338-7.481 3.446-10.544 6.201-3.061 2.754-5.537 6.098-7.279 9.83 5.752-4.338 18.766-10.844 41.681-6.13 0.66 0.094 1.038 0.754 0.943 1.415s-0.754 1.037-1.414 0.943c-30.553-6.13-42.907 8.393-43 8.581-0.223 0.232-0.529 0.368-0.849 0.377z", "M460.544 117.403c-0.565 0-1.038-0.377-1.131-0.849l-3.018-11.882c-0.188-0.66 0.188-1.226 0.849-1.415 0.565-0.189 1.226 0.189 1.414 0.849l3.018 11.882c0.188 0.66-0.19 1.226-0.849 1.414h-0.283zM446.965 184.168c-2.084-0.029-4.090-0.797-5.658-2.17-1.792-1.697-3.584-4.903-2.263-11.032 0.093-0.661 0.754-1.038 1.414-0.849 0.66 0.095 1.038 0.754 0.849 1.414-0.849 3.96-0.378 6.978 1.602 8.77 1.697 1.604 4.055 1.792 4.903 1.509 0.661-0.095 1.321 0.188 1.509 0.754 0.092 0.3 0.065 0.623-0.075 0.905-0.142 0.28-0.384 0.497-0.679 0.604l-1.602 0.095z"],
    width: 1039,
    attrs: [{
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(18, 67, 129)"
    }, {
      fill: "rgb(18, 67, 129)"
    }, {
      fill: "rgb(18, 67, 129)"
    }, {
      fill: "rgb(18, 67, 129)"
    }, {
      fill: "rgb(18, 67, 129)"
    }, {
      fill: "rgb(18, 67, 129)"
    }, {
      fill: "rgb(18, 67, 129)"
    }, {
      fill: "rgb(18, 67, 129)"
    }, {
      fill: "rgb(18, 67, 129)"
    }, {
      fill: "rgb(18, 67, 129)"
    }],
    isMulticolor: true,
    isMulticolor2: false,
    colorPermutations: {
      "186712912552552551": [{
        f: 1
      }, {
        f: 1
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }, {
        f: 0
      }],
      "111311311311867129125525525512929271": [{
        f: 4
      }, {
        f: 4
      }, {
        f: 2
      }, {
        f: 2
      }, {
        f: 2
      }, {
        f: 2
      }, {
        f: 2
      }, {
        f: 2
      }, {
        f: 2
      }, {
        f: 2
      }, {
        f: 2
      }, {
        f: 2
      }]
    },
    tags: ["consult"],
    grid: 0
  },
  attrs: [{
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(18, 67, 129)"
  }, {
    fill: "rgb(18, 67, 129)"
  }, {
    fill: "rgb(18, 67, 129)"
  }, {
    fill: "rgb(18, 67, 129)"
  }, {
    fill: "rgb(18, 67, 129)"
  }, {
    fill: "rgb(18, 67, 129)"
  }, {
    fill: "rgb(18, 67, 129)"
  }, {
    fill: "rgb(18, 67, 129)"
  }, {
    fill: "rgb(18, 67, 129)"
  }, {
    fill: "rgb(18, 67, 129)"
  }],
  properties: {
    order: 74,
    id: 9,
    name: "consult",
    prevSize: 32,
    code: 59680,
    codes: [59680, 59681, 59682, 59683, 59684, 59685, 59686, 59687, 59688, 59689, 59690, 59691]
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 11
}, {
  icon: {
    paths: ["M431.705 601.915c3.489-39.323 33.289-64.123 52.713-94.581 4.338-6.885 4.338-6.885 14.334-19.616 8.864-42.906 42.246-44.698 76.005-49.035 72.8-9.336 145.411-20.369 218.022-30.931 4.715-0.66 9.052-3.584 13.579-5.469l-1.792-8.299-274.411 39.323c-0.754-45.357-18.861-56.296-60.353-38.757-38.097 16.125-58.937 47.244-72.516 84.87l-8.111 0.283-42.529-284.597c80.533-12.353 155.312-23.953 230.186-35.174 64.501-9.712 129.19-18.388 193.598-28.572 15.842-2.546 22.725-0.66 26.309 17.445 36.588 187.186 74.308 374.181 111.651 561.271 7.166 35.834 14.050 71.763 21.499 109.86l-473.478 67.424-24.046-145.976c-4.622-28.196-7.356-56.769-14.334-84.399-2.821-9.567-3.040-19.712-0.637-29.392s7.343-18.543 14.31-25.68c8.582 2.453 1.699 12.071 9.713 10.939 117.686-16.596 251.781-38.757 369.278-56.296 7.45-1.132 14.616-4.622 21.971-6.978l-1.697-6.79c-6.883 0.283-13.768 0.095-20.557 1.038-63.652 9.242-127.304 18.293-190.863 28.101-62.615 9.618-125.229 19.992-187.845 29.987zM859.354 700.741l-2.168-12.259c-131.36 21.784-263.85 36.212-394.927 59.127l1.697 10.656 395.398-57.523zM778.916 258.476l-1.697-11.598-396.152 57.145 1.697 11.693 396.152-57.24z", "M326.465 201.802c2.83 8.016 8.77 16.408 7.921 24.046-3.489 32.25-10.373 64.123-13.39 96.375-1.98 20.933-1.226 42.434 1.98 63.181 0.66 4.149 18.012 5.752 32.25 9.806l20.841 118.536c30.175-8.016 41.208-28.291 51.015-50.074 5.841-14.443 15.227-27.181 27.291-37.037 12.065-9.856 26.419-16.512 41.737-19.354 3.584-0.754 7.638 0.376 18.577 1.131-13.485 27.535-22.444 53.563-37.624 75.252-27.065 38.662-54.883 76.1-71.858 121.174-12.824 34.232-44.32 52.808-74.684 71.48-17.899 10.948-34.182 24.343-48.376 39.794-12.258 13.579-25.083 21.877-42.434 17.634-26.067-6.124-51.733-13.839-76.854-23.103-17.917-6.883-20.086-23.763-6.885-43.189 43.473-64.030 60.824-137.3 76.29-211.42 1.602-7.544 3.96-18.2 9.335-21.030 19.992-10.561 19.992-28.761 24.329-47.149 12.259-51.299 26.687-102.127 40.644-152.954 2.923-10.656 7.45-20.84 11.317-31.214 2.828-0.754 5.658-1.319 8.581-1.885z", "M130.983 710.266c22.915 30.082 62.615 33.664 99.675 44.226 49.884 14.333 65.161-33.477 95.148-53.185 18.578 13.39 21.406 26.592 7.168 42.434-4.338 4.81-7.45 10.844-11.788 15.654-24.612 27.064-40.549 56.486-43.378 94.959-2.64 34.796-14.804 41.303-49.696 41.020-37.626-0.282-75.157-0.282-112.688-2.074-12.089-0.949-23.846-4.418-34.514-10.184-13.579-6.978-19.991-18.671-12.542-34.703 8.204-17.729 15.654-35.739 23.669-53.468 12.825-28.384 26.027-56.674 38.946-84.68z"],
    attrs: [{
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "186712912552552551": [{
        f: 1
      }, {
        f: 1
      }, {
        f: 1
      }],
      "111311311311867129125525525512929271": [{
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }]
    },
    tags: ["instructions"],
    grid: 0
  },
  attrs: [{
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }],
  properties: {
    order: 73,
    id: 10,
    name: "instructions",
    prevSize: 32,
    code: 59692
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 12
}, {
  icon: {
    paths: ["M959.413 277.009c-17.629-24.052-44.884-39.266-74.639-41.637l-615.556-48.752-11.19-63.397c-10.231-57.888-56.292-102.715-114.437-111.316l-77.731-11.542c-18.539-2.722-35.79 10.055-38.539 28.593-2.756 18.555 10.047 35.808 28.586 38.547v-0.016l77.762 11.576c29.212 4.275 52.399 26.837 57.544 55.95l105.362 597.155c9.886 56.051 58.564 96.887 115.482 96.903h432.986c18.745 0 33.927-15.198 33.927-33.916 0-18.739-15.182-33.938-33.927-33.938h-432.988c-23.967 0.016-44.517-17.236-48.677-40.836l-14.738-83.558h482.666c47.783 0 89.234-32.967 99.964-79.532l45.369-196.592c6.715-29.063 0.42-59.609-17.225-83.692z", "M437.947 865.447c-40.301 0-72.96 32.698-72.96 72.984s32.659 72.952 72.96 72.952c40.299 0 72.978-32.666 72.978-72.952-0.002-40.286-32.679-72.984-72.978-72.984z", "M762.12 865.447c-40.313 0-72.963 32.698-72.963 72.984s32.649 72.952 72.963 72.952c40.297 0 72.973-32.666 72.973-72.952s-32.676-72.984-72.973-72.984z"],
    attrs: [{
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }, {
      fill: "rgb(255, 255, 255)"
    }],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": [{
        f: 4
      }, {
        f: 4
      }, {
        f: 4
      }]
    },
    tags: ["shoppingCart"],
    grid: 0
  },
  attrs: [{
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }, {
    fill: "rgb(255, 255, 255)"
  }],
  properties: {
    order: 72,
    id: 11,
    name: "shoppingCart",
    prevSize: 32,
    code: 59693
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 13
}, {
  icon: {
    paths: ["M413.66 235.58v-44.089c-0.22-1.352-0.346-2.91-0.346-4.497 0-16.239 13.164-29.404 29.404-29.404 1.073 0 2.133 0.058 3.177 0.17l-0.13-0.011h128.982c0.81-0.075 1.751-0.118 2.702-0.118 17.149 0 31.052 13.902 31.052 31.052 0 0.412-0.008 0.821-0.024 1.229l0.002-0.059c0.542 34.285 0 45.727 0 45.727", "M669.934 553.702l-64.252 63.518v-233.953h64.252z", "M478.284 383.31h64.316v350.876h-64.316v-350.876z", "M350.025 382.438h64.316v350.876h-64.316v-350.876z", "M637.67 676.548l45.478-45.478 339.461 339.461-45.478 45.478-339.461-339.461z", "M636.883 976.391l48.035 47.609 340.029-337.328-47.992-47.609z", "M830.138 223.935v64.316l-638.414 0v-64.316l638.414-0z", "M733.431 594.208l64.316 65.188v-371.134h-64.316z", "M624.505 893.678l69.452-64.305h-395.22c-7.795-0.16-12.761-0.989-12.931-15.845 0 0-0.734-2.201-1.531-4.094-4.371-10.294-62.582-23.034-62.582-1.499-0.084 1.482-0.132 3.217-0.132 4.962 0 16.754 4.419 32.476 12.156 46.063l-0.241-0.46c6.955 10.274 15.602 18.833 25.628 25.48l0.341 0.212c10.263 6.018 22.602 9.572 35.771 9.572 1.239 0 2.471-0.031 3.694-0.094l-0.172 0.007c29.202-0.33 154.632 3.137 325.768 0z", "M221.691 807.934l64.114 5.583 0.202-526.266h-64.316z"],
    width: 1025,
    attrs: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
    isMulticolor: false,
    isMulticolor2: false,
    tags: ["icons8-remove-96 1"],
    grid: 0
  },
  attrs: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
  properties: {
    order: 155,
    id: 12,
    name: "trashRemove",
    prevSize: 32,
    code: 59677
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 14
}, {
  icon: {
    paths: ["M934.411 439.542h-78.497c5.363-18.972 8.092-38.753 8.097-58.652 0.030-38.228-10.075-75.607-29.035-107.406-18.96-31.798-45.922-56.587-77.474-71.228-31.553-14.642-66.278-18.476-99.779-11.021-33.502 7.455-64.273 25.867-88.421 52.905l-57.291 64.137-57.277-64.23c-27.374-30.619-63.147-50.054-101.575-55.185s-77.282 4.338-110.325 26.889c-33.041 22.551-58.354 56.875-71.872 97.459-13.52 40.586-14.46 85.077-2.672 126.333h-78.679v31.516h90.239c8.112 17.264 18.513 33.054 30.849 46.834l291.456 326.746c1.307 1.465 2.86 2.628 4.57 3.42 1.71 0.794 3.541 1.202 5.392 1.202s3.682-0.408 5.392-1.202c1.71-0.792 3.263-1.956 4.57-3.42l291.456-326.746c12.27-13.8 22.612-29.588 30.68-46.834h90.197v-31.516zM230.552 266.344c13.397-15.046 29.316-26.982 46.844-35.129 17.529-8.145 36.321-12.338 55.299-12.338 18.98 0 37.771 4.193 55.3 12.338 17.527 8.146 33.446 20.083 46.844 35.129l67.231 75.371c2.691 2.852 6.256 4.442 9.963 4.442 3.705 0 7.27-1.59 9.961-4.442l67.218-75.355c20.217-22.62 45.976-38.019 74.017-44.248s57.101-3.011 83.506 9.252c26.405 12.261 48.967 33.013 64.829 59.63 15.863 26.617 24.316 57.903 24.287 89.897-0.026 20.063-3.368 39.949-9.856 58.652h-146.615c-2.49 0-4.937 0.74-7.088 2.143s-3.934 3.42-5.161 5.845l-19.627 38.814-19.628-38.814c-1.118-2.207-2.695-4.082-4.598-5.461s-4.075-2.224-6.333-2.463c-2.257-0.238-4.533 0.138-6.633 1.095-2.099 0.957-3.962 2.468-5.429 4.403l-80.199 105.675-55.292-164.075c-0.939-2.81-2.573-5.262-4.713-7.068s-4.696-2.891-7.369-3.127c-2.667-0.267-5.345 0.334-7.714 1.732-2.368 1.398-4.324 3.533-5.633 6.147l-55.194 109.157-50.688-50.175c-2.574-2.54-5.888-3.941-9.321-3.94h-130.732c-10.095-29.284-12.395-61.214-6.623-91.93 5.773-30.717 19.369-58.904 39.148-81.158zM793.513 495.626l-281.502 315.558-281.459-315.558c-6.684-7.516-12.698-15.744-17.953-24.567h110.74l59.755 59.093c1.572 1.552 3.433 2.692 5.449 3.337 2.014 0.646 4.133 0.779 6.199 0.391s4.031-1.289 5.747-2.634c1.717-1.345 3.143-3.102 4.176-5.144l48.957-96.786 53.137 157.582c0.863 2.573 2.313 4.848 4.204 6.601s4.159 2.92 6.578 3.389c2.421 0.468 4.907 0.22 7.215-0.72 2.307-0.94 4.355-2.539 5.939-4.638l82.594-108.857 21.936 43.398c1.333 2.276 3.152 4.144 5.292 5.439 2.139 1.293 4.533 1.97 6.965 1.97 2.431 0 4.824-0.677 6.965-1.97 2.139-1.294 3.958-3.163 5.292-5.439l27.85-55.012h123.904c-5.272 8.818-11.294 17.045-17.98 24.567z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["heart"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 59,
    id: 13,
    name: "heart",
    prevSize: 32,
    code: 59676
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 15
}, {
  icon: {
    paths: ["M894.898 386.807l-51.2-119.809c-0.799-1.867-2.001-3.519-3.513-4.824-1.512-1.307-3.292-2.234-5.204-2.709l-320-79.873c-1.96-0.492-4.005-0.492-5.965 0l-320 79.873c-1.911 0.475-3.692 1.402-5.204 2.709-1.512 1.306-2.714 2.957-3.513 4.824l-51.2 119.809c-0.761 1.785-1.136 3.722-1.097 5.675 0.039 1.951 0.49 3.871 1.322 5.622 0.832 1.749 2.024 3.288 3.491 4.507 1.468 1.217 3.175 2.085 5.001 2.54l41.382 10.33v336.156c0.001 2.991 0.971 5.892 2.752 8.24 1.781 2.347 4.27 4.002 7.066 4.699l320 79.872c1.96 0.498 4.006 0.498 5.965 0l320-79.872c2.796-0.697 5.285-2.352 7.067-4.699 1.781-2.348 2.749-5.249 2.751-8.24v-336.156l41.382-10.33c1.826-0.455 3.533-1.323 5.001-2.54 1.468-1.219 2.66-2.758 3.492-4.507 0.832-1.751 1.283-3.671 1.323-5.622 0.038-1.953-0.336-3.89-1.098-5.675zM511.999 206.215l265.152 66.189-265.152 66.187-265.152-66.187 265.152-66.189zM199.371 287.925l294.707 73.563-40.627 95.061-294.733-73.549 40.653-95.076zM204.799 421.871l253.018 63.152c2.908 0.725 5.969 0.37 8.651-1.007 2.681-1.377 4.816-3.685 6.030-6.528l26.701-62.487v399.629l-294.4-73.496v-319.263zM819.199 741.134l-294.4 73.496v-399.629l26.701 62.487c1.006 2.354 2.647 4.355 4.723 5.759 2.076 1.402 4.5 2.15 6.976 2.149 1.006 0 2.007-0.125 2.982-0.373l253.018-63.152v319.263zM570.571 456.549l-40.653-95.061 294.682-73.563 40.678 95.076-294.707 73.549z", "M556.105 656.209c1.399 0.97 2.967 1.644 4.617 1.984s3.346 0.338 4.995-0.003c1.648-0.343 3.217-1.020 4.614-1.993s2.596-2.222 3.529-3.676l2.15-3.395v115.816c0 3.53 1.348 6.916 3.749 9.412 2.401 2.497 5.656 3.9 9.051 3.9s6.65-1.402 9.051-3.9c2.401-2.496 3.749-5.882 3.749-9.412v-115.816l2.15 3.355c1.884 2.937 4.813 4.976 8.142 5.668s6.787-0.020 9.611-1.98c2.825-1.96 4.786-5.006 5.45-8.468 0.666-3.463-0.020-7.058-1.904-9.997l-25.6-39.936c-1.239-1.721-2.846-3.119-4.695-4.082-1.847-0.963-3.887-1.465-5.955-1.465-2.066 0-4.106 0.502-5.955 1.465s-3.456 2.361-4.695 4.082l-25.6 39.936c-0.939 1.456-1.591 3.090-1.923 4.81-0.33 1.719-0.33 3.489 0 5.208 0.329 1.719 0.981 3.355 1.92 4.81 0.939 1.456 2.145 2.706 3.548 3.676z", "M663.451 639.243l2.15-3.395v102.504c0 3.53 1.348 6.916 3.749 9.412 2.401 2.497 5.656 3.9 9.051 3.9s6.65-1.402 9.051-3.9c2.401-2.496 3.749-5.882 3.749-9.412v-102.504l2.15 3.355c0.933 1.455 2.132 2.704 3.53 3.676 1.397 0.973 2.964 1.648 4.612 1.991 1.65 0.343 3.346 0.344 4.995 0.004 1.65-0.34 3.218-1.014 4.617-1.984 1.399-0.97 2.6-2.217 3.534-3.671 0.936-1.454 1.587-3.083 1.916-4.797 0.33-1.715 0.33-3.48 0.004-5.195-0.327-1.715-0.976-3.346-1.909-4.801l-25.6-39.936c-1.239-1.721-2.846-3.119-4.695-4.082-1.847-0.963-3.887-1.465-5.955-1.465s-4.106 0.502-5.955 1.465c-1.849 0.963-3.456 2.361-4.695 4.082l-25.6 39.936c-1.884 2.938-2.569 6.534-1.904 9.997 0.666 3.462 2.625 6.508 5.45 8.468s6.282 2.671 9.611 1.98c3.329-0.691 6.258-2.731 8.142-5.668v0.040z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["picto-box"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 32,
    id: 14,
    name: "box",
    prevSize: 32,
    code: 59669
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 16
}, {
  icon: {
    paths: ["M702.663 510.969l122.012-122.012c11.53-11.574 18.004-27.244 18.004-43.58 0-16.337-6.474-32.007-18.004-43.58l-104.586-104.56c-11.57-11.537-27.241-18.014-43.58-18.014s-32.010 6.477-43.58 18.014l-122.012 122.012-122.012-122.012c-11.57-11.537-27.241-18.014-43.578-18.014-16.338 0-32.010 6.477-43.58 18.014l-104.549 104.573c-11.53 11.573-18.004 27.243-18.004 43.58 0 16.336 6.474 32.006 18.004 43.578l122.012 122.012-122.012 122.012c-11.53 11.574-18.004 27.244-18.004 43.58 0 16.337 6.474 32.007 18.004 43.58l104.573 104.573c11.568 11.538 27.24 18.020 43.58 18.020 16.338 0 32.011-6.481 43.58-18.020l122.012-122.012 122.012 122.012c11.568 11.538 27.24 18.020 43.58 18.020 16.338 0 32.010-6.481 43.578-18.020l104.573-104.573c11.53-11.573 18.004-27.243 18.004-43.58 0-16.336-6.474-32.006-18.004-43.58l-122.024-122.024zM650.358 214.663c6.946-6.915 16.35-10.798 26.152-10.798s19.206 3.883 26.153 10.798l104.573 104.573c6.921 6.945 10.807 16.348 10.807 26.153 0 9.803-3.887 19.207-10.807 26.152l-122.012 122.012-156.867-156.891 122.001-122zM667.809 510.969l-156.878 156.878-156.878-156.878 156.878-156.88 156.878 156.88zM214.625 371.541c-6.921-6.945-10.807-16.348-10.807-26.152 0-9.805 3.887-19.209 10.807-26.153l104.573-104.573c6.945-6.921 16.348-10.807 26.153-10.807 9.803 0 19.209 3.887 26.152 10.807l122.012 122.012-156.89 156.865-122.001-122zM371.503 807.275c-6.946 6.915-16.35 10.796-26.152 10.796s-19.206-3.881-26.153-10.796l-104.573-104.575c-6.921-6.943-10.807-16.348-10.807-26.152 0-9.805 3.887-19.209 10.807-26.153l122.012-122.012 156.867 156.891-122.001 122.001zM807.236 702.7l-104.573 104.575c-6.948 6.915-16.351 10.796-26.153 10.796s-19.206-3.881-26.152-10.796l-122.012-122.014 156.89-156.865 122.014 122.012c6.915 6.945 10.796 16.348 10.795 26.149-0.003 9.801-3.888 19.201-10.807 26.143z", "M412.325 523.315h24.649c3.268 0 6.403-1.298 8.715-3.61 2.311-2.311 3.61-5.446 3.61-8.714 0-3.27-1.298-6.404-3.61-8.715-2.313-2.311-5.447-3.61-8.715-3.61h-24.649c-3.27 0-6.404 1.298-8.715 3.61s-3.61 5.446-3.61 8.715c0 3.268 1.298 6.403 3.61 8.714s5.446 3.61 8.715 3.61z", "M498.603 523.315h24.649c3.268 0 6.403-1.298 8.715-3.61 2.311-2.311 3.61-5.446 3.61-8.714 0-3.27-1.298-6.404-3.61-8.715-2.313-2.311-5.447-3.61-8.715-3.61h-24.649c-3.27 0-6.404 1.298-8.715 3.61s-3.61 5.446-3.61 8.715c0 3.268 1.298 6.403 3.61 8.714s5.446 3.61 8.715 3.61z", "M572.555 510.992c0 3.268 1.298 6.403 3.61 8.714s5.447 3.61 8.715 3.61h24.649c3.268 0 6.404-1.298 8.715-3.61s3.61-5.446 3.61-8.714c0-3.27-1.298-6.404-3.61-8.715s-5.447-3.61-8.715-3.61h-24.649c-3.268 0-6.404 1.298-8.715 3.61s-3.61 5.446-3.61 8.715z", "M449.297 473.983h24.649c3.268 0 6.404-1.298 8.715-3.61s3.61-5.447 3.61-8.715c0-3.268-1.298-6.403-3.61-8.714-2.311-2.313-5.447-3.61-8.715-3.61h-24.649c-3.27 0-6.404 1.297-8.715 3.61-2.311 2.311-3.61 5.446-3.61 8.714s1.298 6.404 3.61 8.715c2.311 2.311 5.446 3.61 8.715 3.61z", "M498.603 424.704h24.649c3.268 0 6.403-1.298 8.715-3.61 2.311-2.311 3.61-5.446 3.61-8.714 0-3.27-1.298-6.404-3.61-8.715-2.313-2.311-5.447-3.61-8.715-3.61h-24.649c-3.27 0-6.404 1.298-8.715 3.61s-3.61 5.446-3.61 8.715c0 3.268 1.298 6.403 3.61 8.714s5.446 3.61 8.715 3.61z", "M547.908 473.983h24.649c3.268 0 6.403-1.298 8.715-3.61 2.311-2.311 3.61-5.447 3.61-8.715s-1.298-6.403-3.61-8.714c-2.313-2.313-5.447-3.61-8.715-3.61h-24.649c-3.27 0-6.404 1.297-8.715 3.61-2.311 2.311-3.61 5.446-3.61 8.714s1.298 6.404 3.61 8.715c2.311 2.311 5.446 3.61 8.715 3.61z", "M473.974 547.944h-24.65c-3.268 0-6.403 1.298-8.714 3.611-2.311 2.311-3.61 5.446-3.61 8.714s1.298 6.403 3.61 8.715c2.311 2.311 5.446 3.61 8.714 3.61h24.65c3.268 0 6.403-1.298 8.714-3.61 2.311-2.313 3.61-5.447 3.61-8.715s-1.298-6.403-3.61-8.714c-2.311-2.313-5.446-3.611-8.714-3.611z", "M572.557 547.944h-24.649c-3.27 0-6.404 1.298-8.715 3.611-2.311 2.311-3.61 5.446-3.61 8.714s1.298 6.403 3.61 8.715c2.311 2.311 5.446 3.61 8.715 3.61h24.649c3.268 0 6.403-1.298 8.715-3.61 2.311-2.313 3.61-5.447 3.61-8.715s-1.298-6.403-3.61-8.714c-2.313-2.313-5.447-3.611-8.715-3.611z", "M523.251 597.222h-24.649c-3.27 0-6.404 1.298-8.715 3.61s-3.61 5.446-3.61 8.715c0 3.268 1.298 6.403 3.61 8.714s5.446 3.61 8.715 3.61h24.649c3.268 0 6.403-1.298 8.715-3.61 2.311-2.311 3.61-5.446 3.61-8.714 0-3.27-1.298-6.404-3.61-8.715-2.313-2.311-5.447-3.61-8.715-3.61z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["picto-patch"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 30,
    id: 15,
    name: "patch",
    prevSize: 32,
    code: 59674
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 17
}, {
  icon: {
    paths: ["M165.558 559.795c-3.169 0-6.208-1.259-8.448-3.499s-3.499-5.279-3.499-8.448v-71.68c0-3.169 1.259-6.207 3.499-8.447 2.24-2.241 5.279-3.5 8.448-3.5s6.207 1.259 8.448 3.5c2.24 2.24 3.499 5.278 3.499 8.447v71.68c0 3.169-1.259 6.208-3.499 8.448-2.241 2.24-5.279 3.499-8.448 3.499z", "M858.462 464.225c-3.169 0-6.207 1.259-8.447 3.499-2.241 2.24-3.5 5.279-3.5 8.448v23.893h-71.979c-1.697-38.010-11.686-75.189-29.269-108.929l62.41-36.032 11.947 20.692c1.596 2.722 4.203 4.702 7.252 5.508 3.051 0.806 6.295 0.373 9.027-1.205s4.73-4.171 5.557-7.215c0.826-3.045 0.415-6.293-1.143-9.035l-35.84-62.123c-0.779-1.37-1.822-2.571-3.066-3.537-1.246-0.966-2.67-1.675-4.19-2.088s-3.108-0.521-4.669-0.317c-1.563 0.203-3.069 0.713-4.434 1.5-1.364 0.788-2.559 1.838-3.516 3.089s-1.657 2.681-2.061 4.204c-0.402 1.523-0.499 3.11-0.286 4.672 0.213 1.56 0.734 3.063 1.53 4.423l11.947 20.692-62.446 36.043c-20.543-31.989-47.733-59.177-79.72-79.721l36.043-62.444 20.69 11.947c2.743 1.559 5.99 1.97 9.035 1.143s5.639-2.825 7.216-5.557c1.577-2.732 2.010-5.976 1.203-9.027-0.806-3.049-2.786-5.656-5.508-7.252l-62.123-35.84c-1.358-0.796-2.862-1.317-4.423-1.53-1.56-0.213-3.149-0.117-4.672 0.286-1.523 0.404-2.951 1.104-4.203 2.061s-2.301 2.152-3.089 3.516c-0.788 1.365-1.298 2.871-1.502 4.434-0.203 1.562-0.095 3.149 0.319 4.669 0.412 1.52 1.122 2.944 2.086 4.19 0.966 1.244 2.167 2.287 3.537 3.066l20.692 11.947-36.031 62.409c-33.731-17.559-70.892-27.533-108.882-29.221v-71.979h23.893c3.169 0 6.208-1.259 8.448-3.499 2.24-2.241 3.499-5.279 3.499-8.448s-1.259-6.208-3.499-8.448c-2.24-2.24-5.279-3.499-8.448-3.499h-71.68c-3.169 0-6.207 1.259-8.447 3.499-2.241 2.24-3.5 5.279-3.5 8.448s1.259 6.207 3.5 8.448c2.24 2.24 5.278 3.499 8.447 3.499h23.893v71.979c-38.009 1.697-75.189 11.686-108.929 29.269l-36.031-62.41 20.69-11.947c1.37-0.778 2.573-1.82 3.537-3.065 0.966-1.246 1.675-2.67 2.088-4.19s0.521-3.108 0.319-4.671c-0.203-1.562-0.714-3.069-1.502-4.433-0.788-1.365-1.838-2.56-3.089-3.517s-2.679-1.657-4.203-2.059c-1.523-0.402-3.112-0.501-4.672-0.287-1.562 0.213-3.065 0.734-4.425 1.53l-62.123 35.84c-1.37 0.779-2.571 1.822-3.537 3.066-0.964 1.246-1.674 2.67-2.086 4.19-0.414 1.52-0.522 3.108-0.319 4.669 0.203 1.563 0.714 3.069 1.502 4.434 0.788 1.364 1.838 2.559 3.089 3.516s2.679 1.657 4.203 2.061c1.523 0.402 3.112 0.499 4.672 0.286 1.562-0.213 3.065-0.734 4.423-1.53l20.692-11.947 36.043 62.446c-31.987 20.543-59.177 47.733-79.72 79.72l-62.397-36.043 11.947-20.69c1.559-2.743 1.97-5.99 1.143-9.035s-2.825-5.639-5.557-7.216c-2.731-1.577-5.976-2.010-9.027-1.203-3.049 0.806-5.656 2.786-7.252 5.508l-35.84 62.123c-0.796 1.358-1.317 2.862-1.53 4.423s-0.117 3.149 0.286 4.672c0.404 1.523 1.104 2.951 2.061 4.203s2.152 2.303 3.516 3.089c1.365 0.788 2.871 1.298 4.434 1.502 1.562 0.203 3.149 0.095 4.669-0.319 1.52-0.412 2.944-1.122 4.19-2.086 1.246-0.966 2.287-2.167 3.066-3.537l11.947-20.692 62.409 36.031c-17.576 33.727-27.566 70.889-29.269 108.882h-83.925v23.893h83.925c1.697 38.009 11.686 75.189 29.269 108.929l-62.409 36.031-11.947-20.69c-0.779-1.37-1.82-2.573-3.066-3.537-1.246-0.966-2.67-1.675-4.19-2.088s-3.108-0.521-4.669-0.319c-1.563 0.203-3.069 0.714-4.434 1.502-1.364 0.788-2.559 1.838-3.516 3.089s-1.657 2.679-2.061 4.203c-0.402 1.523-0.499 3.112-0.286 4.672 0.213 1.562 0.734 3.065 1.53 4.425l35.84 62.123c0.778 1.37 1.82 2.571 3.066 3.537 1.244 0.964 2.668 1.674 4.188 2.086 1.52 0.414 3.108 0.522 4.671 0.319 1.562-0.203 3.069-0.714 4.433-1.502 1.365-0.786 2.56-1.838 3.517-3.089s1.657-2.679 2.059-4.203c0.402-1.523 0.501-3.11 0.287-4.672s-0.734-3.065-1.53-4.423l-11.947-20.692 62.444-36.043c20.544 31.987 47.733 59.177 79.721 79.72l-36.043 62.446-20.692-11.947c-2.742-1.559-5.99-1.97-9.035-1.143-3.044 0.826-5.638 2.823-7.215 5.555s-2.011 5.978-1.205 9.027c0.806 3.051 2.786 5.658 5.508 7.253l62.123 35.84c1.36 0.796 2.863 1.317 4.423 1.53 1.562 0.213 3.149 0.115 4.672-0.287s2.953-1.102 4.204-2.059c1.252-0.957 2.301-2.152 3.089-3.517 0.788-1.364 1.297-2.87 1.5-4.433s0.095-3.149-0.317-4.671c-0.412-1.52-1.122-2.944-2.088-4.188-0.966-1.246-2.167-2.287-3.537-3.066l-20.692-11.947 36.032-62.41c33.729 17.56 70.892 27.534 108.881 29.222v71.979h-23.893c-3.169 0-6.207 1.259-8.447 3.499-2.241 2.24-3.5 5.279-3.5 8.448s1.259 6.207 3.5 8.448c2.24 2.24 5.278 3.499 8.447 3.499h71.68c3.169 0 6.208-1.259 8.448-3.499 2.24-2.241 3.499-5.279 3.499-8.448s-1.259-6.208-3.499-8.448c-2.24-2.24-5.279-3.499-8.448-3.499h-23.893v-71.979c38.010-1.697 75.189-11.686 108.929-29.269l36.032 62.409-20.692 11.947c-1.37 0.779-2.571 1.822-3.537 3.066-0.966 1.246-1.675 2.67-2.088 4.19s-0.521 3.108-0.317 4.669c0.203 1.563 0.713 3.069 1.5 4.434 0.788 1.364 1.838 2.559 3.089 3.516s2.681 1.658 4.204 2.061c1.523 0.402 3.11 0.499 4.672 0.286 1.56-0.213 3.063-0.732 4.423-1.53l62.123-35.84c2.722-1.596 4.702-4.203 5.508-7.252 0.806-3.051 0.373-6.295-1.205-9.027s-4.171-4.73-7.215-5.557c-3.045-0.826-6.293-0.415-9.035 1.143l-20.692 11.947-36.043-62.444c31.989-20.543 59.179-47.733 79.721-79.721l62.444 36.043-11.947 20.692c-0.796 1.36-1.317 2.863-1.53 4.423-0.213 1.562-0.115 3.149 0.287 4.672s1.102 2.953 2.059 4.204c0.957 1.252 2.153 2.301 3.517 3.089s2.871 1.297 4.433 1.5c1.563 0.203 3.15 0.095 4.671-0.317s2.944-1.122 4.19-2.088c1.244-0.966 2.287-2.167 3.065-3.537l35.84-62.123c1.56-2.742 1.971-5.99 1.145-9.035-0.828-3.044-2.825-5.638-5.557-7.215s-5.978-2.011-9.027-1.205c-3.051 0.806-5.658 2.786-7.253 5.508l-11.947 20.692-62.409-36.032c17.56-33.729 27.533-70.891 29.221-108.881h71.979v23.893c0 3.169 1.259 6.207 3.5 8.448 2.24 2.24 5.278 3.499 8.447 3.499s6.208-1.259 8.448-3.499c2.24-2.241 3.499-5.279 3.499-8.448v-71.68c0-3.169-1.259-6.208-3.499-8.448s-5.279-3.499-8.448-3.499zM512.009 750.945c-47.256 0-93.451-14.013-132.745-40.267-39.292-26.254-69.916-63.57-88.001-107.23-18.084-43.659-22.815-91.702-13.596-138.049 9.22-46.349 31.976-88.923 65.391-122.338 33.417-33.415 75.989-56.172 122.338-65.391s94.39-4.487 138.049 13.596c43.659 18.085 80.976 48.71 107.23 88.001s40.267 85.488 40.267 132.745c-0.073 63.346-25.269 124.078-70.062 168.87s-105.525 69.99-168.872 70.063z", "M512.007 476.167c-7.088 0-14.019 2.102-19.913 6.040s-10.487 9.535-13.2 16.084c-2.712 6.549-3.422 13.756-2.039 20.708s4.796 13.339 9.809 18.351c5.012 5.012 11.398 8.425 18.35 9.809 6.953 1.382 14.16 0.673 20.708-2.041 6.549-2.712 12.147-7.306 16.085-13.2s6.040-12.823 6.040-19.911c0-9.506-3.776-18.621-10.497-25.343s-15.838-10.497-25.343-10.497zM512.007 523.954c-2.364 0-4.673-0.701-6.638-2.014s-3.496-3.179-4.4-5.362c-0.905-2.183-1.141-4.585-0.68-6.902 0.461-2.318 1.599-4.446 3.27-6.117s3.8-2.809 6.117-3.27c2.317-0.461 4.719-0.225 6.902 0.68s4.049 2.436 5.362 4.4c1.313 1.964 2.014 4.274 2.014 6.638 0 3.169-1.259 6.207-3.5 8.447-2.24 2.241-5.278 3.5-8.447 3.5z", "M595.645 392.556c-7.088 0-14.017 2.102-19.911 6.040s-10.487 9.535-13.2 16.084c-2.714 6.549-3.423 13.756-2.041 20.708 1.384 6.952 4.797 13.338 9.809 18.351 5.013 5.012 11.399 8.425 18.351 9.808 6.952 1.384 14.158 0.674 20.708-2.039 6.549-2.712 12.146-7.306 16.084-13.2s6.040-12.823 6.040-19.911c0-9.506-3.776-18.623-10.497-25.343-6.721-6.721-15.836-10.497-25.343-10.497zM595.645 440.343c-2.362 0-4.672-0.701-6.636-2.014-1.966-1.313-3.496-3.179-4.4-5.362s-1.141-4.585-0.68-6.902c0.461-2.318 1.599-4.446 3.27-6.117 1.67-1.671 3.799-2.809 6.117-3.27 2.317-0.461 4.719-0.225 6.902 0.68s4.049 2.435 5.362 4.4c1.313 1.964 2.012 4.274 2.012 6.638 0 3.167-1.259 6.207-3.499 8.447-2.24 2.241-5.279 3.5-8.448 3.5z", "M428.396 392.556c-7.088 0-14.019 2.102-19.913 6.040s-10.487 9.535-13.2 16.084c-2.712 6.549-3.423 13.756-2.039 20.708 1.382 6.952 4.796 13.338 9.809 18.351 5.012 5.012 11.398 8.425 18.35 9.808 6.953 1.384 14.16 0.674 20.708-2.039 6.549-2.712 12.147-7.306 16.085-13.2s6.040-12.823 6.040-19.911c0-9.506-3.776-18.623-10.497-25.343-6.721-6.721-15.838-10.497-25.343-10.497zM428.396 440.343c-2.364 0-4.673-0.701-6.638-2.014-1.966-1.313-3.496-3.179-4.4-5.362s-1.141-4.585-0.68-6.902c0.461-2.318 1.599-4.446 3.27-6.117s3.799-2.809 6.117-3.27c2.317-0.461 4.719-0.225 6.902 0.68s4.049 2.435 5.362 4.4c1.313 1.964 2.014 4.274 2.014 6.638 0 3.167-1.259 6.207-3.5 8.447-2.24 2.241-5.279 3.5-8.447 3.5z", "M595.645 559.778c-7.088 0-14.017 2.102-19.911 6.040s-10.487 9.535-13.2 16.084c-2.714 6.549-3.423 13.756-2.041 20.708 1.384 6.952 4.797 13.339 9.809 18.351 5.013 5.012 11.399 8.425 18.351 9.809 6.952 1.382 14.158 0.673 20.708-2.039 6.549-2.714 12.146-7.307 16.084-13.201s6.040-12.823 6.040-19.911c0-9.506-3.776-18.621-10.497-25.343s-15.836-10.497-25.343-10.497zM595.645 607.565c-2.362 0-4.672-0.701-6.636-2.014-1.966-1.313-3.496-3.179-4.4-5.362s-1.141-4.585-0.68-6.902c0.461-2.317 1.599-4.446 3.27-6.117 1.67-1.671 3.799-2.809 6.117-3.27 2.317-0.461 4.719-0.225 6.902 0.68s4.049 2.436 5.362 4.4c1.313 1.964 2.012 4.274 2.012 6.638 0 3.169-1.259 6.207-3.499 8.447-2.24 2.241-5.279 3.5-8.448 3.5z", "M428.396 559.778c-7.088 0-14.019 2.102-19.913 6.040s-10.487 9.535-13.2 16.084c-2.712 6.549-3.423 13.756-2.039 20.708 1.382 6.952 4.796 13.339 9.809 18.351 5.012 5.012 11.398 8.425 18.35 9.809 6.953 1.382 14.16 0.673 20.708-2.039 6.549-2.714 12.147-7.307 16.085-13.201s6.040-12.823 6.040-19.911c0-9.506-3.776-18.621-10.497-25.343s-15.838-10.497-25.343-10.497zM428.396 607.565c-2.364 0-4.673-0.701-6.638-2.014-1.966-1.313-3.496-3.179-4.4-5.362s-1.141-4.585-0.68-6.902c0.461-2.317 1.599-4.446 3.27-6.117s3.799-2.809 6.117-3.27c2.317-0.461 4.719-0.225 6.902 0.68s4.049 2.436 5.362 4.4c1.313 1.964 2.014 4.274 2.014 6.638 0 3.169-1.259 6.207-3.5 8.447-2.24 2.241-5.279 3.5-8.447 3.5z", "M512.013 297c-42.532 0-84.107 12.612-119.471 36.241-35.362 23.629-62.925 57.213-79.201 96.506-16.276 39.295-20.534 82.532-12.237 124.245s28.777 80.030 58.852 110.104c30.074 30.073 68.39 50.554 110.104 58.852s84.951 4.039 124.244-12.237c39.295-16.276 72.879-43.839 96.508-79.202 23.629-35.362 36.241-76.938 36.241-119.47-0.067-57.011-22.744-111.669-63.057-151.983-40.314-40.313-94.972-62.99-151.983-63.057zM512.013 703.186c-37.806 0-74.762-11.21-106.196-32.213s-55.933-50.857-70.401-85.784c-14.467-34.928-18.253-73.361-10.877-110.44s25.58-71.138 52.314-97.87c26.732-26.732 60.79-44.938 97.87-52.312 37.079-7.376 75.511-3.591 110.438 10.877 34.928 14.467 64.781 38.967 85.784 70.4 21.003 31.434 32.215 68.39 32.215 106.196-0.061 50.677-20.218 99.261-56.053 135.095-35.834 35.833-84.417 55.991-135.094 56.051z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["picto-virus"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 29,
    id: 16,
    name: "virus",
    prevSize: 32,
    code: 59675
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 18
}, {
  icon: {
    paths: ["M695.164 554.671h-524.497v-85.333h524.497l-225.83-225.831 60.339-60.34 328.836 328.838-328.836 328.836-60.339-60.339 225.83-225.83z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["linkArrow"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 38,
    id: 17,
    name: "linkArrow",
    prevSize: 32,
    code: 59649
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 19
}, {
  icon: {
    paths: ["M471.923 692.582v-524.499h85.333v524.495l225.826-225.826 60.343 60.339-328.836 328.836-328.838-328.836 60.34-60.339 225.832 225.83z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["linkArrowDown"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 40,
    id: 18,
    name: "linkArrowDown",
    prevSize: 32,
    code: 59650
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 20
}, {
  icon: {
    paths: ["M279.017 349.833v543.794h-182.912v-543.794h182.912z", "M291.093 181.638c0 52.214-39.721 93.994-103.5 93.994h-1.169c-61.408 0-101.107-41.78-101.107-93.994 0-53.319 40.908-93.929 103.482-93.929s101.107 40.611 102.294 93.929z", "M938.667 581.85l-0.009 311.795h-182.903v-290.927c0-73.075-26.47-122.94-92.685-122.94-50.534 0-80.631 33.613-93.85 66.082-4.838 11.635-6.025 27.849-6.025 44.1v303.701h-182.935c0 0 2.411-492.768 0-543.795h182.935v77.026c24.277-37.029 67.755-89.809 164.868-89.809 120.367 0 210.603 77.738 210.603 244.766z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["linkedin"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 43,
    id: 19,
    name: "linkedin",
    prevSize: 32,
    code: 59651
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 21
}, {
  icon: {
    paths: ["M706.022 255.923l-172.689-0.006v-85.333l319.996 0.009v320.049h-85.333v-176.012l-256.99 256.989-60.339-60.339 255.356-255.356z", "M170.667 170.667h213.333v85.333h-128v512h512v-128h85.333v213.333h-682.667v-682.667z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["linkExternal"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 44,
    id: 20,
    name: "linkExternal",
    prevSize: 32,
    code: 59652
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 22
}, {
  icon: {
    paths: ["M85.333 170.667h853.333v85.333h-853.333v-85.333z", "M341.333 469.333h597.333v85.333h-597.333v-85.333z", "M85.333 768h853.333v85.333h-853.333v-85.333z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["menu"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 46,
    id: 21,
    name: "menu",
    prevSize: 32,
    code: 59653
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 23
}, {
  icon: {
    paths: ["M865.958 938.667l-293.666-293.7c-130.641 92.873-310.653 70.157-414.121-52.258s-95.87-303.686 17.478-417.013c113.318-113.377 294.618-121.007 417.063-17.551 122.441 103.456 145.173 283.477 52.288 414.118l293.666 293.7-72.708 72.704zM393.625 188.129c-97.441-0.022-181.508 68.374-201.302 163.778-19.794 95.402 30.124 191.594 119.532 230.336s193.733 9.382 249.814-70.302c56.077-79.68 48.495-187.786-18.155-258.864l31.091 30.829-35.661-35.556c-38.451-38.682-90.778-60.367-145.319-60.221z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["search"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 51,
    id: 23,
    name: "search",
    prevSize: 32,
    code: 59655
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 25
}, {
  icon: {
    paths: ["M752.465 895.991c-43.601 0.478-84.928-18.449-111.689-51.153-26.761-32.708-35.874-75.426-24.631-115.447l-252.244-136.973c-43.587 37.939-107.479 45.969-159.951 20.1-52.471-25.865-82.347-80.119-74.792-135.817 7.555-55.703 50.931-100.987 108.591-113.371s117.321 10.772 149.361 57.968l228.995-124.377c-2.965-10.635-4.535-21.577-4.676-32.578-0.576-64.056 46.251-119.701 112.149-133.265s132.77 18.679 160.149 77.218c27.379 58.539 7.748 127.298-47.010 164.672-54.763 37.373-129.617 33.098-179.273-10.24l-247.851 134.56c-0.246 9.929-1.706 19.793-4.352 29.402l252.203 136.93c46.43-40.478 115.516-46.729 169.156-15.3 53.636 31.433 78.763 92.89 61.525 150.477s-72.649 97.284-135.663 97.195zM752.465 704.585c-33.382 0-60.446 25.707-60.446 57.421s27.063 57.421 60.446 57.421c33.378 0 60.442-25.707 60.442-57.421s-27.063-57.421-60.442-57.421zM268.927 436.612c-33.381 0-60.442 25.707-60.442 57.421s27.061 57.425 60.442 57.425c33.382 0 60.442-25.711 60.442-57.425s-27.060-57.421-60.442-57.421zM752.465 206.922c-33.382 0-60.446 25.709-60.446 57.422s27.063 57.423 60.446 57.423c33.378 0 60.442-25.709 60.442-57.423s-27.063-57.422-60.442-57.422z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["share"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 53,
    id: 24,
    name: "share",
    prevSize: 32,
    code: 59656
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 26
}, {
  icon: {
    paths: ["M520.205 128h-0.038c-0.734 0-1.429 0-2.086 0.009-5.257 0.051-13.892 0.131-14.669 0.14-18.944 0-56.845 2.561-97.559 19.763-23.278 9.829-44.216 23.118-62.23 39.5-21.478 19.52-38.975 43.586-51.996 71.54-19.069 40.931-14.543 109.874-10.907 165.278l0.013 0.087c0.389 5.935 0.798 12.13 1.172 18.167-2.798 1.229-7.333 2.526-14.019 2.526-10.756 0-23.548-3.29-38.008-9.775-4.255-1.899-9.111-2.859-14.47-2.859-8.609 0-17.685 2.428-25.558 6.857-9.905 5.568-16.305 13.436-18.043 22.161-1.146 5.769-1.090 17.173 12.145 28.74 7.28 6.37 17.975 12.241 31.779 17.463 3.622 1.365 7.921 2.667 12.475 4.049 15.801 4.809 39.715 12.070 45.952 26.121 3.16 7.125 1.8 16.499-4.031 27.827-0.153 0.307-0.305 0.61-0.445 0.93-1.457 3.255-15.054 32.734-42.942 63.825-15.847 17.681-33.302 32.457-51.852 43.93-22.641 14.007-47.139 23.164-72.808 27.209-10.080 1.587-17.278 10.18-16.716 19.951 0.172 2.816 0.862 5.623 2.059 8.337l0.029 0.051c4.076 9.122 13.525 16.875 28.888 23.714 18.773 8.346 46.85 15.369 83.442 20.86 1.849 3.366 3.768 11.827 5.097 17.617 1.391 6.157 2.842 12.484 4.91 19.209 2.231 7.283 8.019 15.987 22.886 15.987 5.635 0 12.114-1.216 19.618-2.607 10.989-2.065 26.016-4.881 44.771-4.881 10.398 0 21.175 0.879 32.022 2.603 20.909 3.332 38.935 15.522 59.791 29.636 30.527 20.655 65.083 44.036 117.874 44.036 1.442 0 2.884-0.043 4.309-0.141 1.745 0.081 3.908 0.141 6.191 0.141 52.809 0 87.356-23.39 117.85-44.028l0.047-0.043c20.86-14.097 38.865-26.27 59.772-29.602 10.842-1.724 21.615-2.603 32.017-2.603 17.92 0 32.102 2.189 44.77 4.553 8.269 1.557 14.69 2.308 19.622 2.308l0.482 0.009h0.499c10.871 0 18.863-5.713 21.914-15.71 2.027-6.583 3.473-12.766 4.898-19.025 1.242-5.427 3.23-14.127 5.077-17.527 36.617-5.504 64.683-12.51 83.456-20.855 15.33-6.805 24.768-14.549 28.868-23.637 1.229-2.722 1.95-5.547 2.108-8.422 0.58-9.754-6.63-18.364-16.717-19.947-114.078-18.001-165.47-130.202-167.595-134.967-0.137-0.311-0.294-0.623-0.452-0.926-5.833-11.332-7.181-20.698-4.019-27.831 6.225-14.037 30.123-21.299 45.935-26.108 4.578-1.378 8.892-2.692 12.489-4.049 15.565-5.884 26.692-12.271 34.031-19.52 8.764-8.644 10.475-16.926 10.368-22.345-0.269-13.111-10.739-24.759-27.396-30.468-5.628-2.223-12.041-3.401-18.573-3.401-4.45 0-11.034 0.585-17.267 3.371-13.346 5.978-25.301 9.246-35.567 9.711-5.457-0.265-9.284-1.395-11.763-2.479 0.311-5.111 0.657-10.368 1.011-15.845l0.149-2.345c3.657-55.44 8.196-124.436-10.88-165.396-13.077-28.054-30.635-52.182-52.198-71.744-18.086-16.393-39.095-29.68-62.46-39.502-40.653-17.074-78.554-19.625-97.523-19.625z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["snapchat"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 55,
    id: 25,
    name: "snapchat",
    prevSize: 32,
    code: 59657
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 27
}, {
  icon: {
    paths: ["M907.878 197.402l-566.304 702.221-225.262-275.319 66.045-54.037 158.739 194.014 500.359-620.446 66.423 53.568z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["tick"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 56,
    id: 26,
    name: "tick",
    prevSize: 32,
    code: 59671
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 28
}, {
  icon: {
    paths: ["M672.593 128h-134.69v523.127c0 62.336-51.806 113.536-116.273 113.536-64.468 0-116.272-51.2-116.272-113.536 0-61.214 50.653-111.3 112.819-113.527v-131.339c-136.995 2.225-247.511 110.193-247.511 244.866 0 135.795 112.818 244.873 252.115 244.873s252.115-110.191 252.115-244.873v-268.241c50.654 35.618 112.815 56.764 178.436 57.882v-131.342c-101.303-3.339-180.74-83.478-180.74-181.426z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["tiktok"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 33,
    id: 27,
    name: "tiktok",
    prevSize: 32,
    code: 59658
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 29
}, {
  icon: {
    paths: ["M828.719 231.804c34.88 10.163 62.349 40.108 71.671 78.136 16.943 68.922 16.943 212.727 16.943 212.727s0 143.799-16.943 212.727c-9.323 38.029-36.791 67.972-71.671 78.14-63.215 18.466-316.719 18.466-316.719 18.466s-253.504 0-316.722-18.466c-34.882-10.167-62.352-40.111-71.675-78.14-16.937-68.928-16.937-212.727-16.937-212.727s0-143.805 16.937-212.727c9.323-38.028 36.793-67.974 71.675-78.136 63.218-18.47 316.722-18.47 316.722-18.47s253.504 0 316.719 18.47zM436.002 401.621v268.984l202.667-134.485-202.667-134.499z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["youtube"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 36,
    id: 28,
    name: "youtube",
    prevSize: 32,
    code: 59660
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 30
}, {
  icon: {
    paths: ["M170.667 469.333h682.667v85.333h-682.667v-85.333z", "M554.667 170.667l0 682.667h-85.333v-682.667h85.333z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["add"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 37,
    id: 29,
    name: "add",
    prevSize: 32,
    code: 59661
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 31
}, {
  icon: {
    paths: ["M511.996 175.335l-373.663 709.96h747.325l-373.662-709.96zM476.126 106.072c15.198-28.873 56.542-28.874 71.74 0l412.531 783.81c14.208 26.991-5.367 59.413-35.87 59.413h-825.063c-30.502 0-50.075-32.418-35.869-59.413l412.531-783.81z", "M469.333 661.333v-277.333h85.333v277.333h-85.333z", "M469.333 821.333h85.333v-85.333h-85.333v85.333z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["alert"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 39,
    id: 30,
    name: "alert",
    prevSize: 32,
    code: 59662
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 32
}, {
  icon: {
    paths: ["M938.667 307.846l-426.667 481.487-426.667-481.487 71.103-73.18 355.564 408.41 355.563-408.41 71.104 73.18z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["arrowDown"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 41,
    id: 31,
    name: "arrowDown",
    prevSize: 32,
    code: 59663
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 33
}, {
  icon: {
    paths: ["M694.818 938.667l-438.818-426.667 438.818-426.667 73.182 71.103-365.744 355.564 365.744 355.563-73.182 71.104z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["arrowLeft"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 42,
    id: 32,
    name: "arrowLeft",
    prevSize: 32,
    code: 59664
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 34
}, {
  icon: {
    paths: ["M329.18 938.667l438.82-426.667-438.82-426.667-73.18 71.103 365.743 355.564-365.743 355.563 73.18 71.104z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["arrowRight"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 45,
    id: 33,
    name: "arrowRight",
    prevSize: 32,
    code: 59665
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 35
}, {
  icon: {
    paths: ["M938.667 716.151l-426.667-481.485-426.667 481.485 71.103 73.182 355.564-408.41 355.563 408.41 71.104-73.182z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["arrowUp"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 47,
    id: 34,
    name: "arrowUp",
    prevSize: 32,
    code: 59666
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 36
}, {
  icon: {
    paths: ["M134.948 197.833l69.186-69.818 691.863 698.182-69.186 69.818-691.863-698.182z", "M128 826.167l69.186 69.818 691.863-698.182-69.186-69.818-691.863 698.182z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["close"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 49,
    id: 35,
    name: "close",
    prevSize: 32,
    code: 59667
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 37
}, {
  icon: {
    paths: ["M736.644 546.999l-181.999 197.167v-637.5h-85.333v637.461l-181.963-197.129-62.703 57.882 229.34 248.452h-219.34v85.333h554.666v-85.333h-219.307l229.342-248.452-62.703-57.882z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["download"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 50,
    id: 36,
    name: "download",
    prevSize: 32,
    code: 59668
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 38
}, {
  icon: {
    paths: ["M582.383 938.667v-448.051h126.221l16.73-154.403h-142.95l0.213-77.28c0-40.27 3.904-61.848 62.933-61.848h78.912v-154.419h-126.242c-151.637 0-205.012 74.901-205.012 200.862v92.702h-94.521v154.402h94.521v448.034h189.196z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["facebook"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 54,
    id: 37,
    name: "facebook",
    prevSize: 32,
    code: 59670
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 39
}, {
  icon: {
    paths: ["M170.667 469.333h682.667v85.333h-682.667v-85.333z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["hide"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 57,
    id: 38,
    name: "hide",
    prevSize: 32,
    code: 59673
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 40
}, {
  icon: {
    paths: ["M512.077 196.926c102.699 0 114.863 0.451 155.251 2.252 37.538 1.652 57.805 7.958 71.322 13.213 17.865 6.907 30.78 15.315 44.143 28.678 13.513 13.513 21.769 26.276 28.676 44.143 5.257 13.513 11.563 33.933 13.214 71.32 1.801 40.54 2.253 52.702 2.253 155.254 0 102.699-0.452 114.863-2.253 155.251-1.651 37.538-7.957 57.805-13.214 71.322-6.908 17.865-15.313 30.78-28.676 44.143-13.517 13.513-26.278 21.769-44.143 28.676-13.517 5.257-33.937 11.563-71.322 13.214-40.542 1.801-52.702 2.253-155.251 2.253-102.703 0-114.864-0.452-155.254-2.253-37.537-1.651-57.807-7.957-71.32-13.214-17.868-6.908-30.78-15.313-44.143-28.676-13.513-13.513-21.771-26.278-28.678-44.143-5.255-13.517-11.561-33.937-13.213-71.322-1.802-40.542-2.252-52.702-2.252-155.251 0-102.702 0.451-114.864 2.252-155.254 1.652-37.537 7.958-57.807 13.213-71.32 6.907-17.868 15.315-30.78 28.678-44.143 13.513-13.513 26.276-21.772 44.143-28.678 13.513-5.255 33.933-11.561 71.32-13.213 40.39-1.802 52.551-2.252 155.254-2.252zM512.077 127.708c-104.354 0-117.417 0.451-158.407 2.252-40.84 1.802-68.917 8.408-93.241 17.868-25.375 9.91-46.846 22.973-68.167 44.444-21.471 21.321-34.534 42.792-44.443 68.017-9.46 24.474-16.066 52.401-17.868 93.242-1.802 41.14-2.252 54.203-2.252 158.555 0 104.354 0.451 117.414 2.252 158.404 1.802 40.841 8.408 68.919 17.868 93.244 9.91 25.374 22.973 46.844 44.443 68.164 21.321 21.325 42.792 34.534 68.017 44.297 24.474 9.459 52.401 16.064 93.241 17.865 40.99 1.805 54.053 2.253 158.404 2.253 104.354 0 117.419-0.448 158.409-2.253 40.841-1.801 68.915-8.405 93.239-17.865 25.225-9.762 46.699-22.972 68.019-44.297 21.321-21.321 34.534-42.79 44.292-68.015 9.459-24.474 16.064-52.403 17.869-93.239 1.801-40.994 2.249-54.054 2.249-158.409 0-104.351-0.448-117.414-2.249-158.404-1.805-40.84-8.41-68.918-17.869-93.242-9.459-25.525-22.524-46.996-43.994-68.317-21.321-21.321-42.79-34.534-68.015-44.294-24.478-9.459-52.403-16.066-93.244-17.868-41.139-1.952-54.204-2.403-158.554-2.403z", "M512.085 314.625c-109.008 0-197.445 88.437-197.445 197.443 0 109.009 88.437 197.444 197.445 197.444 109.005 0 197.444-88.435 197.444-197.444 0-109.007-88.439-197.443-197.444-197.443zM512.085 640.145c-70.72 0-128.077-57.357-128.077-128.077s57.357-128.075 128.077-128.075c70.72 0 128.077 57.355 128.077 128.075s-57.357 128.077-128.077 128.077z", "M763.477 306.863c0 25.535-20.727 46.113-46.114 46.113-25.536 0-46.114-20.728-46.114-46.113 0-25.535 20.727-46.113 46.114-46.113s46.114 20.728 46.114 46.113z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["instagram"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 34,
    id: 39,
    name: "instagram",
    prevSize: 32,
    code: 59672
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 41
}, {
  icon: {
    paths: ["M150.016 873.984c-96.436-93.233-156.308-223.762-156.308-368.276 0-282.77 229.23-512 512-512 144.514 0 275.043 59.872 368.137 156.164l0.138 0.144c88.925 91.979 143.724 217.436 143.724 355.692 0 282.77-229.23 512-512 512-138.256 0-263.713-54.799-355.836-143.863l0.144 0.138zM801.792 801.792c74.164-74.164 120.036-176.621 120.036-289.792 0-226.342-183.486-409.828-409.828-409.828-113.171 0-215.628 45.872-289.792 120.036v0c-74.164 74.164-120.036 176.621-120.036 289.792 0 226.342 183.486 409.828 409.828 409.828 113.171 0 215.628-45.872 289.792-120.036v0zM460.8 563.2v-102.4h102.4v307.2h-102.4v-204.8zM460.8 256h102.4v102.4h-102.4v-102.4z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["tooltip"],
    grid: 0
  },
  attrs: [],
  properties: {
    order: 2,
    id: 40,
    name: "tooltip",
    prevSize: 32,
    code: 59648
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 42
}, {
  icon: {
    paths: ["M506.667 938.667l193.067-512h87.467l198.4 512h-92.8l-43.733-134.4h-204.8l-50.133 134.4h-87.467zM667.733 729.6h151.467l-74.667-206.933h-2.133l-74.667 206.933zM170.667 810.667l-58.667-58.667 217.6-217.6q-40.533-46.933-72-94.4t-54.933-98.667h92.8q18.133 35.2 40 66.667t49.6 64.533q48-50.133 80-104t54.4-112.533h-476.8v-85.333h298.667v-85.333h85.333v85.333h298.667v85.333h-120.533q-23.467 73.6-62.4 144.533t-95.467 134.933l104.533 105.6-32 86.4-135.467-130.133-213.333 213.333z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    colorPermutations: {
      "111311311311867129125525525512929271": []
    },
    tags: ["translation"],
    defaultCode: 59648,
    grid: 0
  },
  attrs: [],
  properties: {
    ligatures: "translation",
    name: "translation",
    order: 7,
    id: 41,
    prevSize: 32,
    code: 59920
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 43
}, {
  icon: {
    paths: ["M994.133 512c0 266.274-215.859 482.133-482.133 482.133s-482.133-215.859-482.133-482.133c0-266.275 215.858-482.133 482.133-482.133s482.133 215.858 482.133 482.133z", "M275.948 867.507c-0.777-7.808-1.175-15.731-1.175-23.748 0-130.914 106.125-237.039 237.039-237.039 130.91 0 237.035 106.125 237.035 237.039 0 8.017-0.397 15.94-1.173 23.748-67.563 44.902-148.659 71.066-235.861 71.066-87.206 0-168.3-26.163-235.863-71.066h-0.001z", "M640 469.333c0 70.69-57.306 128-128 128s-128-57.306-128-128c0-70.692 57.306-128 128-128s128 57.307 128 128z"],
    attrs: [{
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinejoin: "miter",
      strokeLinecap: "butt",
      strokeMiterlimit: "4",
      strokeWidth: 59.73333333333333
    }, {}, {}],
    isMulticolor: false,
    isMulticolor2: true,
    colorPermutations: {
      "111311311311867129125525525512929271": [{
        s: 0
      }, {}, {}]
    },
    tags: ["profile"],
    grid: 0
  },
  attrs: [{
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: "4",
    strokeWidth: 59.73333333333333
  }, {}, {}],
  properties: {
    order: 156,
    id: 42,
    name: "profile",
    prevSize: 32,
    code: 59694
  },
  setIdx: 0,
  setId: 1,
  iconIdx: 44
}, {
  icon: {
    paths: ["M864 128l-480 480-224-224-160 160 384 384 640-640z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    tags: ["checkmark", "tick", "correct", "accept", "ok"],
    defaultCode: 59920,
    grid: 16
  },
  attrs: [],
  properties: {
    ligatures: "checkmark, tick",
    name: "checkmark",
    order: 7,
    id: 0,
    prevSize: 32,
    code: 59921
  },
  setIdx: 1,
  setId: 0,
  iconIdx: 0
}, {
  icon: {
    paths: ["M512 192c-223.318 0-416.882 130.042-512 320 95.118 189.958 288.682 320 512 320 223.312 0 416.876-130.042 512-320-95.116-189.958-288.688-320-512-320zM764.45 361.704c60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-89.56 0-176.858-25.486-252.452-73.704-60.158-38.372-111.138-89.772-149.432-150.296 38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.86-7.3-9.96 27.328-15.41 56.822-15.41 87.596 0 141.382 114.616 256 256 256 141.382 0 256-114.618 256-256 0-30.774-5.452-60.268-15.408-87.598 3.978 2.378 7.938 4.802 11.858 7.302v0zM512 416c0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.982 96 96z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    tags: ["eye", "views", "vision", "visit"],
    defaultCode: 59854,
    grid: 16
  },
  attrs: [],
  properties: {
    ligatures: "eye, views",
    name: "eye",
    order: 78,
    id: 1,
    prevSize: 32,
    code: 59854
  },
  setIdx: 1,
  setId: 0,
  iconIdx: 1
}, {
  icon: {
    paths: ["M945.942 14.058c-18.746-18.744-49.136-18.744-67.882 0l-202.164 202.164c-51.938-15.754-106.948-24.222-163.896-24.222-223.318 0-416.882 130.042-512 320 41.122 82.124 100.648 153.040 173.022 207.096l-158.962 158.962c-18.746 18.746-18.746 49.136 0 67.882 9.372 9.374 21.656 14.060 33.94 14.060s24.568-4.686 33.942-14.058l864-864c18.744-18.746 18.744-49.138 0-67.884zM416 320c42.24 0 78.082 27.294 90.92 65.196l-121.724 121.724c-37.902-12.838-65.196-48.68-65.196-90.92 0-53.020 42.98-96 96-96zM110.116 512c38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.862-7.3-9.962 27.328-15.412 56.822-15.412 87.596 0 54.89 17.286 105.738 46.7 147.418l-60.924 60.924c-52.446-36.842-97.202-83.882-131.66-138.342z", "M768 442c0-27.166-4.256-53.334-12.102-77.898l-321.808 321.808c24.568 7.842 50.742 12.090 77.91 12.090 141.382 0 256-114.618 256-256z", "M830.026 289.974l-69.362 69.362c1.264 0.786 2.53 1.568 3.786 2.368 60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-38.664 0-76.902-4.76-113.962-14.040l-76.894 76.894c59.718 21.462 123.95 33.146 190.856 33.146 223.31 0 416.876-130.042 512-320-45.022-89.916-112.118-166.396-193.974-222.026z"],
    attrs: [],
    isMulticolor: false,
    isMulticolor2: false,
    tags: ["eye-blocked", "views", "vision", "visit", "banned", "blocked", "forbidden", "private"],
    defaultCode: 59857,
    grid: 16
  },
  attrs: [],
  properties: {
    ligatures: "eye-blocked, views4",
    name: "eye-blocked",
    order: 13,
    id: 2,
    prevSize: 32,
    code: 59857
  },
  setIdx: 1,
  setId: 0,
  iconIdx: 2
}, {
  icon: {
    paths: ["M204.8-0c-112.804 0-204.8 91.994-204.8 204.8v614.401c0 112.804 91.994 204.8 204.8 204.8h409.601c112.804 0 204.8-91.994 204.8-204.8v-430.409c0-25.533-9.547-50.164-26.761-69.026l-261.361-286.393c-19.394-21.251-46.871-33.373-75.64-33.373zM204.8 51.199h250.639c14.402 0 28.113 6.050 37.821 16.688l261.361 286.393c8.612 9.437 13.38 21.731 13.38 34.512v430.409c0 85.135-68.467 153.6-153.6 153.6h-409.601c-85.135 0-153.6-68.467-153.6-153.6v-614.401c0-85.135 68.467-153.6 153.6-153.6z", "M435.2 51.199v230.4c0 70.389 57.61 127.999 127.999 127.999h204.802v-51.199h-204.802c-42.72 0-76.8-34.081-76.8-76.8v-230.4z", "M331.791 453.962c-27.985-0.636-56.293 12.997-70.409 41.229l-144.832 289.665c-25.052 50.107 12.669 111.145 68.691 111.145h452.773c54.62 0 92.37-58.084 70.179-107.993v0.005l-50.187-112.922c-13.013-29.28-41.706-45.386-69.577-45.605s-56.81 15.434-70.282 44.506h-0.002l-20.325 43.868-97.563-219.511c-12.819-28.845-40.481-43.75-68.466-44.386zM330.683 502.737c9.075 0.206 18.032 5.706 22.786 16.404l144.741 325.66h-312.968c-20.102 0-31.885-19.069-22.896-37.048l144.832-289.665c5.235-10.47 14.43-15.558 23.506-15.352zM588.029 680.682c9.66 0.076 18.342 4.29 23.191 15.202l50.187 112.924c7.914 17.8-3.906 35.993-23.393 35.993h-83.777l-28.788-64.779 39.152-84.506c5.021-10.833 13.769-14.909 23.428-14.834z", "M537.598 460.798c-42.113 0-76.8 34.688-76.8 76.8s34.688 76.802 76.8 76.802c42.113 0 76.8-34.69 76.8-76.802s-34.688-76.8-76.8-76.8zM537.598 512c14.441 0 25.601 11.157 25.601 25.598s-11.16 25.601-25.601 25.601c-14.441 0-25.601-11.16-25.601-25.601s11.16-25.598 25.601-25.598z"],
    attrs: [{}, {}, {}, {}],
    isMulticolor: false,
    isMulticolor2: false,
    grid: 0,
    tags: ["file"]
  },
  attrs: [{}, {}, {}, {}],
  properties: {
    order: 5,
    id: 0,
    name: "file",
    prevSize: 32,
    code: 59648
  },
  setIdx: 0,
  setId: 2,
  iconIdx: 0
}];
var height = 1024;
var metadata = {
  name: "icomoon"
};
var preferences = {
  showGlyphs: true,
  showQuickUse: true,
  showQuickUse2: true,
  showSVGs: true,
  fontPref: {
    prefix: "icon-",
    metadata: {
      fontFamily: "icomoon",
      majorVersion: 1,
      minorVersion: 0
    },
    metrics: {
      emSize: 1024,
      baseline: 6.25,
      whitespace: 50
    },
    embed: false,
    showMetadata: false
  },
  imagePref: {
    prefix: "icon-",
    png: true,
    useClassSelector: true,
    color: 0,
    bgColor: 16777215,
    classSelector: ".icon",
    name: "icomoon"
  },
  historySize: 50,
  showCodes: true,
  gridSize: 16,
  showGrid: false
};
var iconSet = {
  IcoMoonType: IcoMoonType,
  icons: icons,
  height: height,
  metadata: metadata,
  preferences: preferences
};
const Icon = /*#__PURE__*/forwardRef((_a, ref) => {
  var {
    className,
    classNameContainer,
    icon,
    color,
    size = 24,
    customIcons = [],
    isWrapped
  } = _a,
      htmlProperties = __rest$3(_a, ["className", "classNameContainer", "icon", "color", "size", "customIcons", "isWrapped"]);

  const renderContent = useMemo(() => jsx(IcomoonReact, Object.assign({
    ref: ref,
    iconSet: Object.assign(Object.assign({}, iconSet), {
      icons: [...iconSet.icons, ...customIcons]
    }),
    icon: icon,
    className: classNames('cds-icon', className),
    color: color,
    size: size
  }, htmlProperties)), [ref, customIcons, icon, className, color, size, htmlProperties]);
  return isWrapped ? jsx("div", Object.assign({
    className: classNames('cds-icon-container', classNameContainer)
  }, {
    children: renderContent
  })) : renderContent;
});

try {
  if (process.env.TOKENS_FEATURE_FLAG === 'true') require('./index-new.css');else require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css not found, proceeding without it.');
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest$2(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const Button = /*#__PURE__*/forwardRef((_a, ref) => {
  var {
    variant = 'primary',
    size = 'small',
    type = 'button',
    children,
    className,
    iconPrefix,
    iconSuffix,
    isLoading
  } = _a,
      htmlProperties = __rest$2(_a, ["variant", "size", "type", "children", "className", "iconPrefix", "iconSuffix", "isLoading"]);

  const IconPrefixComponent = (iconPrefix === null || iconPrefix === void 0 ? void 0 : iconPrefix.component) || Icon;
  const IconSuffixComponent = (iconSuffix === null || iconSuffix === void 0 ? void 0 : iconSuffix.component) || Icon;
  return jsxs("button", Object.assign({
    ref: ref,
    className: classNames('cds-btn', className, `cds-btn--${variant}`, `cds-btn--${variant}-${size}`),
    type: type
  }, htmlProperties, {
    children: [(iconPrefix === null || iconPrefix === void 0 ? void 0 : iconPrefix.props) && jsx(IconPrefixComponent, Object.assign({
      className: classNames('icon__prefix', `icon--${variant}-icon`, {
        'cds-btn--hide': isLoading
      })
    }, iconPrefix.props)), jsx("span", Object.assign({
      className: classNames('cds-btn__inner', {
        'cds-sr-only': variant.includes('-icon'),
        'cds-btn--hide': isLoading
      })
    }, {
      children: children
    })), isLoading && jsx("div", Object.assign({
      className: classNames('cds-btn__loader', `cds-btn__loader--${variant}`)
    }, {
      children: jsx("span", {})
    })), (iconSuffix === null || iconSuffix === void 0 ? void 0 : iconSuffix.props) && jsx(IconSuffixComponent, Object.assign({
      className: classNames('icon__suffix', `icon--${variant}-icon`, {
        'cds-btn--hide': isLoading
      })
    }, iconSuffix.props))]
  }));
});

try {
  require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css not found, proceeding without it.');
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest$1(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const Link = /*#__PURE__*/forwardRef((_a, ref) => {
  var {
    variant = 'primary',
    size = 'small',
    children,
    className,
    iconPrefix,
    iconSuffix,
    href
  } = _a,
      htmlProperties = __rest$1(_a, ["variant", "size", "children", "className", "iconPrefix", "iconSuffix", "href"]);

  const IconPrefixComponent = (iconPrefix === null || iconPrefix === void 0 ? void 0 : iconPrefix.component) || Icon;
  const IconSuffixComponent = (iconSuffix === null || iconSuffix === void 0 ? void 0 : iconSuffix.component) || Icon;
  return jsxs("a", Object.assign({
    ref: ref,
    href: href,
    className: classNames('cds-link', className, `cds-link--${variant}`, `cds-link--${variant}-${size}`)
  }, htmlProperties, {
    children: [(iconPrefix === null || iconPrefix === void 0 ? void 0 : iconPrefix.props) && jsx(IconPrefixComponent, Object.assign({
      className: classNames('icon__prefix', `icon--${variant}-icon`)
    }, iconPrefix.props)), jsx("span", Object.assign({
      className: classNames('cds-link__inner', {
        'cds-sr-only': variant.includes('-icon')
      })
    }, {
      children: children
    })), (iconSuffix === null || iconSuffix === void 0 ? void 0 : iconSuffix.props) && jsx(IconSuffixComponent, Object.assign({
      className: classNames('icon__suffix', `icon--${variant}-icon`)
    }, iconSuffix.props))]
  }));
});

try {
  if (process.env.TOKENS_FEATURE_FLAG === 'true') require('./index-new.css');else require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css not found, proceeding without it.');
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const getClassName = _ref => {
  let {
    align,
    variant,
    wrapping,
    className,
    size,
    weight
  } = _ref;
  const isBodyOrHeadlineOrDetail = variant === 'body' || variant === 'headline' || variant === 'detail';
  return classNames('cds-typography', className, {
    [`cds-typography--align-${align}`]: align,
    [`cds-typography--variant-${variant}`]: variant,
    [`cds-typography--variant-${variant}-${size}`]: isBodyOrHeadlineOrDetail && size,
    [`cds-typography--wrapping-${wrapping}`]: wrapping,
    [`cds-typography--weight-${weight}`]: isBodyOrHeadlineOrDetail && weight
  });
};

const unwrapFirstTag = (typographyTag, typographyVariant, typographyContent) => {
  const openTagRegExp = /^<\/?[^>]+(>|$)/g;
  const closeTagRegExp = /<\/[^>]+(>$)/g;
  return typographyVariant !== 'rte' && typographyTag !== 'div' ? typographyContent.toString().replace(openTagRegExp, '').replace(closeTagRegExp, '') : typographyContent;
};

const Typography = /*#__PURE__*/forwardRef((_a, ref) => {
  var {
    content,
    tag = 'div',
    variant,
    align,
    className,
    size = 'm',
    weight = 'regular',
    wrapping = 'break-word',
    link
  } = _a,
      htmlProperties = __rest(_a, ["content", "tag", "variant", "align", "className", "size", "weight", "wrapping", "link"]);

  const LinkElement = (link === null || link === void 0 ? void 0 : link.component) || Link;
  const typographyClassName = getClassName({
    align,
    variant,
    wrapping,
    className,
    size,
    weight
  });
  const Tag = tag && variant !== 'rte' ? tag : 'div';
  const html = unwrapFirstTag(tag, variant, content);
  return link ? jsx(Tag, Object.assign({
    className: typographyClassName,
    ref: ref
  }, htmlProperties, {
    children: jsx(LinkElement, Object.assign({}, link.props, {
      iconPrefix: undefined,
      iconSuffix: undefined
    }, {
      children: jsx("span", {
        dangerouslySetInnerHTML: {
          __html: html
        }
      })
    }))
  })) : jsx(Tag, Object.assign({
    className: typographyClassName,
    ref: ref,
    dangerouslySetInnerHTML: {
      __html: html
    }
  }, htmlProperties));
});

const CheckboxField = forwardRef((_a, ref) => {
    var { className, id, label, description, tooltipLabel, tooltipText, name, defaultChecked, errorMessage, onChange, onBlur, isDisabled, isError, variant = 'outline', isHidden, checked, hideCheckbox, showMoreText, showLessText, extendedDescription } = _a, rest = __rest$4(_a, ["className", "id", "label", "description", "tooltipLabel", "tooltipText", "name", "defaultChecked", "errorMessage", "onChange", "onBlur", "isDisabled", "isError", "variant", "isHidden", "checked", "hideCheckbox", "showMoreText", "showLessText", "extendedDescription"]);
    const [checkedState, setCheckedState] = useState(checked);
    const [showExtendedDescription, setShowExtendedDescription] = useState(false);
    useEffect(() => {
        setCheckedState(checked);
    }, [checked]);
    const onKeyDown = useCallback((e) => {
        if (e.key === 'Enter' && onChange) {
            onChange(e);
            setCheckedState(e.target.checked);
        }
    }, [onChange]);
    const handleOnChange = useCallback((e) => {
        if (onChange) {
            onChange(e);
            setCheckedState(e.target.checked);
        }
    }, [onChange]);
    return (jsx("div", Object.assign({ className: classNames('cds-checkbox-field', className, {
            'cds-checkbox-field--hidden': isHidden,
        }) }, { children: jsxs("header", Object.assign({ className: "cds-checkbox-field__header" }, { children: [!hideCheckbox ? (jsx("input", Object.assign({ className: classNames('cds-checkbox-field__input', {
                        'cds-checkbox-field__input--error': isError,
                        'cds-checkbox-field__input--disabled': isDisabled,
                    }), "aria-invalid": Boolean(errorMessage), id: id, type: "checkbox", name: name, onChange: handleOnChange, onKeyDown: onKeyDown, defaultChecked: defaultChecked, checked: checkedState, onBlur: onBlur, ref: ref, disabled: isDisabled }, rest))) : null, jsxs("label", Object.assign({ className: classNames('cds-checkbox-field__label', {
                        'cds-checkbox-field__label--error': isError,
                        'cds-checkbox-field__label--disabled': isDisabled,
                        'cds-checkbox-field__label--filled': variant === 'filled',
                    }), htmlFor: id }, { children: [jsxs("div", Object.assign({ className: "cds-checkbox-field__text" }, { children: [label && (jsx("div", Object.assign({ className: classNames('cds-checkbox-field__title-wrapper', {
                                        'cds-checkbox-field__title-wrapper--hidden': description,
                                    }) }, { children: typeof label === 'string' ? (jsx(Typography, { tag: "span", variant: "headline", className: "cds-checkbox-field__title", size: "xs", content: label })) : (jsx("span", Object.assign({ className: "cds-checkbox-field__title" }, { children: label }))) }))), description ? (jsx(RTEText, { text: description, className: "cds-checkbox-field__rte" })) : null, jsx("div", Object.assign({ className: "cds-checkbox-field__error" }, { children: jsx(ErrorMessage, { message: errorMessage }) })), extendedDescription && showLessText && showMoreText ? (jsx(Button, Object.assign({ onClick: () => setShowExtendedDescription(!showExtendedDescription), className: classNames('cds-checkbox-field__button', {
                                        'cds-checkbox-field__button-extended': showExtendedDescription,
                                    }) }, { children: showExtendedDescription ? showLessText : showMoreText }))) : null, extendedDescription && showExtendedDescription ? (jsx(RTEText, { text: extendedDescription, className: "cds-checkbox-field__rte-extend" })) : null] })), tooltipLabel && tooltipText ? (jsx(Tooltip, { label: tooltipLabel, text: tooltipText })) : null] }))] })) })));
});

export { CheckboxField };
